<template>
  <div ref="proData" id="proData" :class="activateComparison ? 'dataTables activateComparison' : 'dataTables'">
    <el-table ref="proCoderTable" v-if="grouping === '1'" key="proByCoder" :data="isIE11 ? coderTablePagination : coderTableData" empty-text="No Coder Data Available" :height="400" :summary-method="getSummaries" show-summary stripe>
      <el-table-column prop="codeDesc" label="Code Type" sortable> </el-table-column>
      <el-table-column prop="coder" label="Coder" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.coder, filterCriteria)" :class="`proCoder_coder_${scope.$index} details`" @click="buildPivotDataStats('Coder Stats', scope.row.totalRecords, scope.row.reimbInc, scope.row.reimbDec, scope.row.recordsWithRecommendations, scope.row.originalWorkRvu, scope.row.recommendedWorkRvu, scope.row.rvuDiff, { table: 'proCoder', prop: 'coder', index: scope.$index, row: scope.row }, $event, scope.row.coder)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="totalRecords" label="Total Instances" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.totalRecords, filterCriteria)" title="View Account Numbers" class="details" @click="buildAccountNumbers(`Coder ${scope.row.coder}`, scope.row, $event)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="totalCodes" label="Total Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('Total Codes', scope, null)">N/A</div>
          <div v-if="scope.row.totalCodes" v-html="highlightValue(`${(scope.row.totalCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`proCoder_totalCodes_${scope.$index} details`" @click="buildPivotData('Total Codes', scope.row.dxNoRec + scope.row.emNoRec + scope.row.cptNoRec + scope.row.modNoRec, scope.row.dxAdditions + scope.row.emAdditions + scope.row.cptAdditions + scope.row.modAdditions, scope.row.dxDeletions + scope.row.emDeletions + scope.row.cptDeletions + scope.row.modDeletions, scope.row.dxRevisions + scope.row.emRevisions + scope.row.cptRevisions + scope.row.modRevisions, { table: 'proCoder', prop: 'proTotalCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.totalCodes * 100).toFixed(2)}%`)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="cmCodes" label="ICD-10 CM Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('ICD-10 CM Codes', scope, null)">
            N/A
          </div>
          <div v-else v-html="highlightValue(`${(scope.row.cmCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`proCoder_cmCodes_${scope.$index} details`" @click="buildPivotData('ICD-10 CM Codes', scope.row.dxNoRec, scope.row.dxAdditions, scope.row.dxDeletions, scope.row.dxRevisions, { table: 'proCoder', prop: 'cmCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.cmCodes * 100).toFixed(2)}%`)">
            {{ `${(scope.row.cmCodes * 100).toFixed(2)}%` }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="emCodes" label="E/M Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('E/M Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.emCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`proCoder_emCodes_${scope.$index} details`" @click="buildPivotData('E/M Codes', scope.row.emNoRec, scope.row.emAdditions, scope.row.emDeletions, scope.row.emRevisions, { table: 'proCoder', prop: 'emCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.emCodes * 100).toFixed(2)}%`)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="cptCodes" label="CPT Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('CPT Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.cptCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`proCoder_cptCodes_${scope.$index} details`" @click="buildPivotData('CPT Codes', scope.row.cptNoRec, scope.row.cptAdditions, scope.row.cptDeletions, scope.row.cptRevisions, { table: 'proCoder', prop: 'cptCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.cptCodes * 100).toFixed(2)}%`)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="modCodes" label="MOD Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('MOD Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.modCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`proCoder_modCodes_${scope.$index} details`" @click="buildPivotData('MOD Codes', scope.row.modNoRec, scope.row.modAdditions, scope.row.modDeletions, scope.row.modRevisions, { table: 'proCoder', prop: 'modCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.modCodes * 100).toFixed(2)}%`)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="rvuDiff" label="RVU Impact" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('rvu', scope)">
            N/A
          </div>
          <div v-else v-html="highlightValue(`${scope.row.rvuDiff}`, filterCriteria)" :class="`proCoder_rvuDiff_${scope.$index} details ${scope.row.rvuDiff < 0 ? 'negativeNumber' : ''}`" @click="buildPivotRVUData('RVU Impact', scope.row.originalWorkRvu, scope.row.recommendedWorkRvu, scope.row.rvuDiff, { table: 'proCoder', prop: 'rvuDiff', index: scope.$index, row: scope.row }, $event, `${scope.row.rvuDiff}`)"></div>
        </template>
      </el-table-column>
    </el-table>

    <el-table ref="proCoderTrendingTable" v-if="grouping === '15'" key="proByCoderTrending" :data="isIE11 ? coderTrendingTablePagination : coderTrendingTableData" empty-text="No Coder Data Available" :height="400" :summary-method="getSummaries" show-summary stripe>
      <el-table-column prop="codeDesc" label="Code Type" sortable> </el-table-column>
      <el-table-column prop="coder" label="Coder" sortable>
        <template slot-scope="scope">
          <!-- <div v-html="highlightValue(scope.row.coder, filterCriteria)" :class="`proCoderTrending_coder_${scope.$index} details`" @click="buildPivotDataStats('Coder Stats', scope.row.totalRecords, scope.row.reimbInc, scope.row.reimbDec, scope.row.recordsWithRecommendations, scope.row.originalWorkRvu, scope.row.recommendedWorkRvu, scope.row.rvuDiff, { table: 'proCoder', prop: 'coder', index: scope.$index, row: scope.row })"></div> -->
          <div v-html="highlightValue(scope.row.coder, filterCriteria)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="projectName" label="Project" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.projectName, filterCriteria)" :class="`proCoderTrending_projectName_${scope.$index} details`" @click="buildPivotDataStats('Project Stats', scope.row.totalRecords, scope.row.reimbInc, scope.row.reimbDec, scope.row.recordsWithRecommendations, scope.row.originalWorkRvu, scope.row.recommendedWorkRvu, scope.row.rvuDiff, { table: 'proCoderTrending', prop: 'projectName', index: scope.$index, row: scope.row }, $event, scope.row.projectName)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="projectStartDate" label="Start Date" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(formatDate(scope.row.projectStartDate), filterCriteria)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="totalRecords" label="Total Instances" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.totalRecords, filterCriteria)" title="View Account Numbers" class="details" @click="buildAccountNumbers(`Coder ${scope.row.coder}`, scope.row, $event)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="totalCodes" label="Total Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('Total Codes', scope, null)">N/A</div>
          <div v-if="scope.row.totalCodes" v-html="highlightValue(`${(scope.row.totalCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`proCoderTrending_totalCodes_${scope.$index} details`" @click="buildPivotData('Total Codes', scope.row.dxNoRec + scope.row.emNoRec + scope.row.cptNoRec + scope.row.modNoRec, scope.row.dxAdditions + scope.row.emAdditions + scope.row.cptAdditions + scope.row.modAdditions, scope.row.dxDeletions + scope.row.emDeletions + scope.row.cptDeletions + scope.row.modDeletions, scope.row.dxRevisions + scope.row.emRevisions + scope.row.cptRevisions + scope.row.modRevisions, { table: 'proCoderTrending', prop: 'proTotalCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.totalCodes * 100).toFixed(2)}%`)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="cmCodes" label="ICD-10 CM Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('ICD-10 CM Codes', scope, null)">
            N/A
          </div>
          <div v-else v-html="highlightValue(`${(scope.row.cmCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`proCoderTrending_cmCodes_${scope.$index} details`" @click="buildPivotData('ICD-10 CM Codes', scope.row.dxNoRec, scope.row.dxAdditions, scope.row.dxDeletions, scope.row.dxRevisions, { table: 'proCoderTrending', prop: 'cmCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.cmCodes * 100).toFixed(2)}%`)">
            {{ `${(scope.row.cmCodes * 100).toFixed(2)}%` }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="emCodes" label="E/M Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('E/M Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.emCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`proCoderTrending_emCodes_${scope.$index} details`" @click="buildPivotData('E/M Codes', scope.row.emNoRec, scope.row.emAdditions, scope.row.emDeletions, scope.row.emRevisions, { table: 'proCoderTrending', prop: 'emCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.emCodes * 100).toFixed(2)}%`)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="cptCodes" label="CPT Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('CPT Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.cptCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`proCoderTrending_cptCodes_${scope.$index} details`" @click="buildPivotData('CPT Codes', scope.row.cptNoRec, scope.row.cptAdditions, scope.row.cptDeletions, scope.row.cptRevisions, { table: 'proCoderTrending', prop: 'cptCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.cptCodes * 100).toFixed(2)}%`)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="modCodes" label="MOD Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('MOD Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.modCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`proCoderTrending_modCodes_${scope.$index} details`" @click="buildPivotData('MOD Codes', scope.row.modNoRec, scope.row.modAdditions, scope.row.modDeletions, scope.row.modRevisions, { table: 'proCoderTrending', prop: 'modCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.modCodes * 100).toFixed(2)}%`)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="rvuDiff" label="RVU Impact" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('rvu', scope)">
            N/A
          </div>
          <div v-else v-html="highlightValue(`${scope.row.rvuDiff}`, filterCriteria)" :class="`proCoderTrending_rvuDiff_${scope.$index} details ${scope.row.rvuDiff < 0 ? 'negativeNumber' : ''}`" @click="buildPivotRVUData('RVU Impact', scope.row.originalWorkRvu, scope.row.recommendedWorkRvu, scope.row.rvuDiff, { table: 'proCoderTrending', prop: 'rvuDiff', index: scope.$index, row: scope.row }, $event, `${scope.row.rvuDiff}`)"></div>
        </template>
      </el-table-column>
    </el-table>

    <el-table ref="proProviderTable" v-if="grouping === '2'" key="proByProvider" :data="isIE11 ? providerTablePagination : providerTableData" empty-text="No Provider Data Available" :height="400" :summary-method="getSummaries" show-summary stripe>
      <el-table-column prop="codeDesc" label="Code Type" sortable> </el-table-column>
      <el-table-column prop="physicianName" label="Provider" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.physicianName, filterCriteria)" :class="`proProvider_physicianName_${scope.$index} details`" @click="buildPivotDataStats('Provider Stats', scope.row.totalRecords, scope.row.reimbInc, scope.row.reimbDec, scope.row.recordsWithRecommendations, scope.row.originalWorkRvu, scope.row.recommendedWorkRvu, scope.row.rvuDiff, { table: 'proProvider', prop: 'physicianName', index: scope.$index, row: scope.row }, $event, scope.row.physicianName)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="totalRecords" label="Total Instances" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.totalRecords, filterCriteria)" title="View Account Numbers" class="details" @click="buildAccountNumbers(`Coder ${scope.row.coder}`, scope.row, $event)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="totalCodes" label="Total Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('Total Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.totalCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`proProvider_totalCodes_${scope.$index} details`" @click="buildPivotData('Total Codes', scope.row.dxNoRec + scope.row.emNoRec + scope.row.cptNoRec + scope.row.modNoRec, scope.row.dxAdditions + scope.row.emAdditions + scope.row.cptAdditions + scope.row.modAdditions, scope.row.dxDeletions + scope.row.emDeletions + scope.row.cptDeletions + scope.row.modDeletions, scope.row.dxRevisions + scope.row.emRevisions + scope.row.cptRevisions + scope.row.modRevisions, { table: 'proProvider', prop: 'proTotalCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.totalCodes * 100).toFixed(2)}%`)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="cmCodes" label="ICD-10 CM Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('ICD-10 CM Codes', scope, null)">
            N/A
          </div>
          <div v-else v-html="highlightValue(`${(scope.row.cmCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`proProvider_cmCodes_${scope.$index} details`" @click="buildPivotData('ICD-10 CM Codes', scope.row.dxNoRec, scope.row.dxAdditions, scope.row.dxDeletions, scope.row.dxRevisions, { table: 'proProvider', prop: 'cmCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.cmCodes * 100).toFixed(2)}%`)">
            {{ `${(scope.row.cmCodes * 100).toFixed(2)}%` }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="emCodes" label="E/M Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('E/M Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.emCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`proProvider_emCodes_${scope.$index} details`" @click="buildPivotData('E/M Codes', scope.row.emNoRec, scope.row.emAdditions, scope.row.emDeletions, scope.row.emRevisions, { table: 'proProvider', prop: 'emCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.emCodes * 100).toFixed(2)}%`)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="cptCodes" label="CPT Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('CPT Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.cptCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`proProvider_cptCodes_${scope.$index} details`" @click="buildPivotData('CPT Codes', scope.row.cptNoRec, scope.row.cptAdditions, scope.row.cptDeletions, scope.row.cptRevisions, { table: 'proProvider', prop: 'cptCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.cptCodes * 100).toFixed(2)}%`)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="modCodes" label="MOD Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('MOD Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.modCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`proProvider_modCodes_${scope.$index} details`" @click="buildPivotData('MOD Codes', scope.row.modNoRec, scope.row.modAdditions, scope.row.modDeletions, scope.row.modRevisions, { table: 'proProvider', prop: 'modCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.modCodes * 100).toFixed(2)}%`)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="rvuDiff" label="RVU Impact" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('rvu', scope)">
            N/A
          </div>
          <div v-else v-html="highlightValue(`${scope.row.rvuDiff}`, filterCriteria)" :class="`proProvider_rvuDiff_${scope.$index} details ${scope.row.rvuDiff < 0 ? 'negativeNumber' : ''}`" @click="buildPivotRVUData('RVU Impact', scope.row.originalWorkRvu, scope.row.recommendedWorkRvu, scope.row.rvuDiff, { table: 'proProvider', prop: 'rvuDiff', index: scope.$index, row: scope.row }, $event, `${scope.row.rvuDiff}`)"></div>
        </template>
      </el-table-column>
    </el-table>

    <el-table ref="proProviderTrendingTable" v-if="grouping === '14'" key="proByProviderTrending" :data="isIE11 ? providerTrendingTablePagination : providerTrendingTableData" empty-text="No Provider Data Available" :height="400" :summary-method="getSummaries" show-summary stripe>
      <el-table-column prop="codeDesc" label="Code Type" sortable> </el-table-column>
      <el-table-column prop="physicianName" label="Provider" sortable>
        <template slot-scope="scope">
          <!-- <div v-html="highlightValue(scope.row.physicianName, filterCriteria)" :class="`proProvider_physicianName_${scope.$index} details`" @click="buildPivotDataStats('Provider Stats', scope.row.totalRecords, scope.row.reimbInc, scope.row.reimbDec, scope.row.recordsWithRecommendations, scope.row.originalWorkRvu, scope.row.recommendedWorkRvu, scope.row.rvuDiff, { table: 'proProvider', prop: 'physicianName', index: scope.$index, row: scope.row })"></div> -->
          <div v-html="highlightValue(scope.row.physicianName, filterCriteria)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="projectName" label="Project" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.projectName, filterCriteria)" :class="`proProviderTrending_projectName_${scope.$index} details`" @click="buildPivotDataStats('Project Stats', scope.row.totalRecords, scope.row.reimbInc, scope.row.reimbDec, scope.row.recordsWithRecommendations, scope.row.originalWorkRvu, scope.row.recommendedWorkRvu, scope.row.rvuDiff, { table: 'proProviderTrending', prop: 'projectName', index: scope.$index, row: scope.row }, $event, scope.row.projectName)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="projectStartDate" label="Start Date" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(formatDate(scope.row.projectStartDate), filterCriteria)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="totalRecords" label="Total Instances" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.totalRecords, filterCriteria)" title="View Account Numbers" class="details" @click="buildAccountNumbers(`Coder ${scope.row.coder}`, scope.row, $event)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="totalCodes" label="Total Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('Total Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.totalCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`proProviderTrending_totalCodes_${scope.$index} details`" @click="buildPivotData('Total Codes', scope.row.dxNoRec + scope.row.emNoRec + scope.row.cptNoRec + scope.row.modNoRec, scope.row.dxAdditions + scope.row.emAdditions + scope.row.cptAdditions + scope.row.modAdditions, scope.row.dxDeletions + scope.row.emDeletions + scope.row.cptDeletions + scope.row.modDeletions, scope.row.dxRevisions + scope.row.emRevisions + scope.row.cptRevisions + scope.row.modRevisions, { table: 'proProviderTrending', prop: 'proTotalCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.totalCodes * 100).toFixed(2)}%`)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="cmCodes" label="ICD-10 CM Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('ICD-10 CM Codes', scope, null)">
            N/A
          </div>
          <div v-else v-html="highlightValue(`${(scope.row.cmCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`proProviderTrending_cmCodes_${scope.$index} details`" @click="buildPivotData('ICD-10 CM Codes', scope.row.dxNoRec, scope.row.dxAdditions, scope.row.dxDeletions, scope.row.dxRevisions, { table: 'proProviderTrending', prop: 'cmCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.cmCodes * 100).toFixed(2)}%`)">
            {{ `${(scope.row.cmCodes * 100).toFixed(2)}%` }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="emCodes" label="E/M Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('E/M Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.emCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`proProviderTrending_emCodes_${scope.$index} details`" @click="buildPivotData('E/M Codes', scope.row.emNoRec, scope.row.emAdditions, scope.row.emDeletions, scope.row.emRevisions, { table: 'proProviderTrending', prop: 'emCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.emCodes * 100).toFixed(2)}%`)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="cptCodes" label="CPT Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('CPT Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.cptCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`proProviderTrending_cptCodes_${scope.$index} details`" @click="buildPivotData('CPT Codes', scope.row.cptNoRec, scope.row.cptAdditions, scope.row.cptDeletions, scope.row.cptRevisions, { table: 'proProviderTrending', prop: 'cptCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.cptCodes * 100).toFixed(2)}%`)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="modCodes" label="MOD Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('MOD Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.modCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`proProviderTrending_modCodes_${scope.$index} details`" @click="buildPivotData('MOD Codes', scope.row.modNoRec, scope.row.modAdditions, scope.row.modDeletions, scope.row.modRevisions, { table: 'proProviderTrending', prop: 'modCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.modCodes * 100).toFixed(2)}%`)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="rvuDiff" label="RVU Impact" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('rvu', scope)">
            N/A
          </div>
          <div v-else v-html="highlightValue(`${scope.row.rvuDiff}`, filterCriteria)" :class="`proProviderTrending_rvuDiff_${scope.$index} details ${scope.row.rvuDiff < 0 ? 'negativeNumber' : ''}`" @click="buildPivotRVUData('RVU Impact', scope.row.originalWorkRvu, scope.row.recommendedWorkRvu, scope.row.rvuDiff, { table: 'proProviderTrending', prop: 'rvuDiff', index: scope.$index, row: scope.row }, $event, `${scope.row.rvuDiff}`)"></div>
        </template>
      </el-table-column>
    </el-table>

    <el-table ref="proPatientTypeTable" v-if="grouping === '3'" key="proByPatType" :data="isIE11 ? patientTypeTablePagination : patientTypeTableData" :fit="true" empty-text="No Patient Type Data Available" :height="400" :summary-method="getSummaries" show-summary stripe>
      <el-table-column v-if="activateComparison && comparisonAccountsPRO.length" prop="codeDesc" label=" " width="25">
        <template slot-scope="scope">
          <div>
            <i :title="`${currentClient} reviews`" style="float: left; font-size: 23px; margin: -1px 0px 0px -7px; color: rgba(19, 86, 149, .8);" :tag="scope.row.codeDesc" class="mdi mdi-set-center"></i>
          </div>
          <div>
            <i title="All Profee reviews" style="float: left; font-size: 23px; margin: -2px 0px 0px -7px; color: rgba(236, 0, 140, 0.8);" class="mdi mdi-set-all"></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="codeDesc" label="Code Type" sortable>
        <template slot-scope="scope">
          <div :title="scope.row.codeDesc">{{ scope.row.codeDesc }}</div>
          <div :title="scope.row.codeDesc" v-if="activateComparison && comparisonAccountsPRO.length">
            {{ getBedSizeValue('patTypeDesc', scope.row.patTypeDesc, 'codeDesc', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="patTypeDesc" label="Patient Type" sortable>
        <template slot-scope="scope">
          <div :title="scope.row.patTypeDesc" v-html="highlightValue(scope.row.patTypeDesc, filterCriteria)" :class="`propattype_patTypeDesc_${scope.$index} details`" @click="buildPivotDataStats('Patient Type Stats', scope.row.totalRecords, scope.row.reimbInc, scope.row.reimbDec, scope.row.recordsWithRecommendations, scope.row.originalWorkRvu, scope.row.recommendedWorkRvu, scope.row.rvuDiff, { table: 'propattype', prop: 'patTypeDesc', index: scope.$index, row: scope.row }, $event, scope.row.patTypeDesc)"></div>
          <div :title="scope.row.patTypeDesc" v-if="activateComparison && comparisonAccountsPRO.length">
            {{ getBedSizeValue('patTypeDesc', scope.row.patTypeDesc, 'patTypeDesc', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="totalRecords" label="Total Instances" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.totalRecords, filterCriteria)" title="View Account Numbers" class="details" @click="buildAccountNumbers(`Patient Type ${scope.row.patTypeDesc}`, scope.row, $event)"></div>
          <div v-if="activateComparison && comparisonAccountsPRO.length">
            {{ getBedSizeValue('patTypeDesc', scope.row.patTypeDesc, 'totalRecords', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="activateComparison" prop="numClients" label="# Clients">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.numClients, filterCriteria)"></div>
          <div v-if="activateComparison && comparisonAccountsPRO.length">
            {{ getBedSizeValue('patTypeDesc', scope.row.patTypeDesc, 'numClients', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="totalCodes" label="Total Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('Total Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.totalCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`propattype_totalCodes_${scope.$index} details`" @click="buildPivotData('Total Codes', scope.row.dxNoRec + scope.row.emNoRec + scope.row.cptNoRec + scope.row.modNoRec, scope.row.dxAdditions + scope.row.emAdditions + scope.row.cptAdditions + scope.row.modAdditions, scope.row.dxDeletions + scope.row.emDeletions + scope.row.cptDeletions + scope.row.modDeletions, scope.row.dxRevisions + scope.row.emRevisions + scope.row.cptRevisions + scope.row.modRevisions, { table: 'propattype', prop: 'proTotalCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.totalCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccountsPRO.length">
            {{ getBedSizeValue('patTypeDesc', scope.row.patTypeDesc, 'totalCodes', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="cmCodes" label="ICD-10 CM Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('ICD-10 CM Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.cmCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`propattype_cmCodes_${scope.$index} details`" @click="buildPivotData('ICD-10 CM Codes', scope.row.dxNoRec, scope.row.dxAdditions, scope.row.dxDeletions, scope.row.dxRevisions, { table: 'propattype', prop: 'cmCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.cmCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccountsPRO.length">
            {{ getBedSizeValue('patTypeDesc', scope.row.patTypeDesc, 'cmCodes', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="emCodes" label="E/M Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('E/M Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.emCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`propattype_emCodes_${scope.$index} details`" @click="buildPivotData('E/M Codes', scope.row.emNoRec, scope.row.emAdditions, scope.row.emDeletions, scope.row.emRevisions, { table: 'propattype', prop: 'emCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.emCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccountsPRO.length">
            {{ getBedSizeValue('patTypeDesc', scope.row.patTypeDesc, 'emCodes', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="cptCodes" label="CPT Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('CPT Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.cptCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`propattype_cptCodes_${scope.$index} details`" @click="buildPivotData('CPT Codes', scope.row.cptNoRec, scope.row.cptAdditions, scope.row.cptDeletions, scope.row.cptRevisions, { table: 'propattype', prop: 'cptCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.cptCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccountsPRO.length">
            {{ getBedSizeValue('patTypeDesc', scope.row.patTypeDesc, 'cptCodes', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="modCodes" label="MOD Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('MOD Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.modCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`propattype_modCodes_${scope.$index} details`" @click="buildPivotData('MOD Codes', scope.row.modNoRec, scope.row.modAdditions, scope.row.modDeletions, scope.row.modRevisions, { table: 'propattype', prop: 'modCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.modCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccountsPRO.length">
            {{ getBedSizeValue('patTypeDesc', scope.row.patTypeDesc, 'modCodes', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="rvuDiff" label="RVU Impact" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('rvu', scope)">
            N/A
          </div>
          <div v-else v-html="highlightValue(`${scope.row.rvuDiff}`, filterCriteria)" :class="`propattype_rvuDiff_${scope.$index} details ${scope.row.rvuDiff < 0 ? 'negativeNumber' : ''}`" @click="buildPivotRVUData('RVU Impact', scope.row.originalWorkRvu, scope.row.recommendedWorkRvu, scope.row.rvuDiff, { table: 'propattype', prop: 'rvuDiff', index: scope.$index, row: scope.row }, $event, `${scope.row.rvuDiff}`)"></div>
          <div v-if="activateComparison && comparisonAccountsPRO.length" :class="`${getBedSizeValue('patTypeDesc', scope.row.patTypeDesc, 'rvuDiff', scope.row.codeDesc, true) < 0 ? 'negativeNumber' : ''}`">
            {{ getBedSizeValue('patTypeDesc', scope.row.patTypeDesc, 'rvuDiff', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-table ref="proFacilityTable" v-if="grouping === '4'" key="proByFacility" :data="isIE11 ? facilityTablePagination : facilityTableData" :fit="true" empty-text="No Patient Type Data Available" :height="400" :summary-method="getSummaries" show-summary stripe>
      <el-table-column v-if="activateComparison && comparisonAccountsPRO.length" prop="codeDesc" label=" " width="25">
        <template slot-scope="scope">
          <div>
            <i :title="`${currentClient} reviews`" style="float: left; font-size: 23px; margin: -1px 0px 0px -7px; color: rgba(19, 86, 149, .8);" :tag="scope.row.codeDesc" class="mdi mdi-set-center"></i>
          </div>
          <div>
            <i title="All Profee reviews" style="float: left; font-size: 23px; margin: -2px 0px 0px -7px; color: rgba(236, 0, 140, 0.8);" class="mdi mdi-set-all"></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="codeDesc" label="Code Type" sortable>
        <template slot-scope="scope">
          <div :title="scope.row.codeDesc">{{ scope.row.codeDesc }}</div>
          <div v-if="activateComparison && comparisonAccountsPRO.length">
            {{ getBedSizeValue('cliName', scope.row.cliName, 'codeDesc', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="cliName" label="Facility" sortable>
        <template slot-scope="scope">
          <div :title="scope.row.cliName" v-html="highlightValue(scope.row.cliName, filterCriteria)" :class="`proFacility_cliName_${scope.$index} details`" @click="buildPivotDataStats('Facility Stats', scope.row.totalRecords, scope.row.reimbInc, scope.row.reimbDec, scope.row.recordsWithRecommendations, scope.row.originalWorkRvu, scope.row.recommendedWorkRvu, scope.row.rvuDiff, { table: 'proFacility', prop: 'cliName', index: scope.$index, row: scope.row }, $event, scope.row.cliName)"></div>
          <div title="All Profee reviews" v-if="activateComparison && comparisonAccountsPRO.length">
            All Profee reviews
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="totalRecords" label="Total Instances" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.totalRecords, filterCriteria)" title="View Account Numbers" class="details" @click="buildAccountNumbers(`Facility ${scope.row.cliName}`, scope.row, $event)"></div>
          <div v-if="activateComparison && comparisonAccountsPRO.length">
            {{ getBedSizeValue('cliName', scope.row.cliName, 'totalRecords', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="activateComparison" prop="numClients" label="# Clients">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.numClients, filterCriteria)"></div>
          <div v-if="activateComparison && comparisonAccountsPRO.length">
            {{ getBedSizeValue('cliName', scope.row.cliName, 'numClients', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="totalCodes" label="Total Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('Total Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.totalCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`proFacility_totalCodes_${scope.$index} details`" @click="buildPivotData('Total Codes', scope.row.dxNoRec + scope.row.emNoRec + scope.row.cptNoRec + scope.row.modNoRec, scope.row.dxAdditions + scope.row.emAdditions + scope.row.cptAdditions + scope.row.modAdditions, scope.row.dxDeletions + scope.row.emDeletions + scope.row.cptDeletions + scope.row.modDeletions, scope.row.dxRevisions + scope.row.emRevisions + scope.row.cptRevisions + scope.row.modRevisions, { table: 'proFacility', prop: 'proTotalCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.totalCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccountsPRO.length">
            {{ getBedSizeValue('cliName', scope.row.cliName, 'totalCodes', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="cmCodes" label="ICD-10 CM Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('ICD-10 CM Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.cmCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`proFacility_cmCodes_${scope.$index} details`" @click="buildPivotData('ICD-10 CM Codes', scope.row.dxNoRec, scope.row.dxAdditions, scope.row.dxDeletions, scope.row.dxRevisions, { table: 'proFacility', prop: 'cmCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.cmCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccountsPRO.length">
            {{ getBedSizeValue('cliName', scope.row.cliName, 'cmCodes', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="emCodes" label="E/M Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('E/M Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.emCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`proFacility_emCodes_${scope.$index} details`" @click="buildPivotData('E/M Codes', scope.row.emNoRec, scope.row.emAdditions, scope.row.emDeletions, scope.row.emRevisions, { table: 'proFacility', prop: 'emCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.emCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccountsPRO.length">
            {{ getBedSizeValue('cliName', scope.row.cliName, 'emCodes', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="cptCodes" label="CPT Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('CPT Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.cptCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`proFacility_cptCodes_${scope.$index} details`" @click="buildPivotData('CPT Codes', scope.row.cptNoRec, scope.row.cptAdditions, scope.row.cptDeletions, scope.row.cptRevisions, { table: 'proFacility', prop: 'cptCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.cptCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccountsPRO.length">
            {{ getBedSizeValue('cliName', scope.row.cliName, 'cptCodes', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="modCodes" label="MOD Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('MOD Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.modCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`proFacility_modCodes_${scope.$index} details`" @click="buildPivotData('MOD Codes', scope.row.modNoRec, scope.row.modAdditions, scope.row.modDeletions, scope.row.modRevisions, { table: 'proFacility', prop: 'modCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.modCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccountsPRO.length">
            {{ getBedSizeValue('cliName', scope.row.cliName, 'modCodes', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="rvuDiff" label="RVU Impact" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('rvu', scope)">
            N/A
          </div>
          <div v-else v-html="highlightValue(`${scope.row.rvuDiff}`, filterCriteria)" :class="`proFacility_rvuDiff_${scope.$index} details ${scope.row.rvuDiff < 0 ? 'negativeNumber' : ''}`" @click="buildPivotRVUData('RVU Impact', scope.row.originalWorkRvu, scope.row.recommendedWorkRvu, scope.row.rvuDiff, { table: 'proFacility', prop: 'rvuDiff', index: scope.$index, row: scope.row }, $event, `${scope.row.rvuDiff}`)"></div>
          <div v-if="activateComparison && comparisonAccountsPRO.length" :class="`${getBedSizeValue('cliName', scope.row.cliName, 'rvuDiff', scope.row.codeDesc, true) < 0 ? 'negativeNumber' : ''}`">
            {{ getBedSizeValue('cliName', scope.row.cliName, 'rvuDiff', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-table ref="proProjectTable" v-if="grouping === '17'" key="proByProject" :data="isIE11 ? projectTablePagination : projectTableData" :fit="true" empty-text="No Project Data Available" :height="400" :summary-method="getSummaries" show-summary stripe>
      <el-table-column v-if="activateComparison && comparisonAccountsPRO.length" prop="codeDesc" label=" " width="25">
        <template slot-scope="scope">
          <div>
            <i :title="`${currentClient} reviews`" style="float: left; font-size: 23px; margin: -1px 0px 0px -7px; color: rgba(19, 86, 149, .8);" :tag="scope.row.codeDesc" class="mdi mdi-set-center"></i>
          </div>
          <div>
            <i title="All Profee reviews" style="float: left; font-size: 23px; margin: -2px 0px 0px -7px; color: rgba(236, 0, 140, 0.8);" class="mdi mdi-set-all"></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="codeDesc" label="Code Type" sortable>
        <template slot-scope="scope">
          <div :title="scope.row.codeDesc">{{ scope.row.codeDesc }}</div>
          <div v-if="activateComparison && comparisonAccountsPRO.length">
            {{ getBedSizeValue('projectName', scope.row.projectName, 'codeDesc', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="projectName" label="Project" sortable>
        <template slot-scope="scope">
          <div :title="scope.row.projectName" v-html="highlightValue(scope.row.projectName, filterCriteria)" :class="`proProject_projectName_${scope.$index} details`" @click="buildPivotDataStats('Project Stats', scope.row.totalRecords, scope.row.reimbInc, scope.row.reimbDec, scope.row.recordsWithRecommendations, scope.row.originalWorkRvu, scope.row.recommendedWorkRvu, scope.row.rvuDiff, { table: 'proProject', prop: 'projectName', index: scope.$index, row: scope.row }, $event, scope.row.projectName)"></div>
          <div title="All Profee reviews" v-if="activateComparison && comparisonAccountsPRO.length">
            All Profee reviews
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="projectStartDate" label="Start Date" sortable width="120">
        <template slot-scope="scope">
          <div v-html="highlightValue(formatDate(scope.row.projectStartDate), filterCriteria)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="totalRecords" label="Total Instances" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.totalRecords, filterCriteria)" title="View Account Numbers" class="details" @click="buildAccountNumbers(`Project ${scope.row.projectName}`, scope.row, $event)"></div>
          <div v-if="activateComparison && comparisonAccountsPRO.length">
            {{ getBedSizeValue('projectName', scope.row.projectName, 'totalRecords', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="activateComparison" prop="numClients" label="# Clients">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.numClients, filterCriteria)"></div>
          <div v-if="activateComparison && comparisonAccountsPRO.length">
            {{ getBedSizeValue('projectName', scope.row.projectName, 'numClients', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="totalCodes" label="Total Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('Total Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.totalCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`proProject_totalCodes_${scope.$index} details`" @click="buildPivotData('Total Codes', scope.row.dxNoRec + scope.row.emNoRec + scope.row.cptNoRec + scope.row.modNoRec, scope.row.dxAdditions + scope.row.emAdditions + scope.row.cptAdditions + scope.row.modAdditions, scope.row.dxDeletions + scope.row.emDeletions + scope.row.cptDeletions + scope.row.modDeletions, scope.row.dxRevisions + scope.row.emRevisions + scope.row.cptRevisions + scope.row.modRevisions, { table: 'proProject', prop: 'proTotalCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.totalCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccountsPRO.length">
            {{ getBedSizeValue('projectName', scope.row.projectName, 'totalCodes', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="cmCodes" label="ICD-10 CM Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('ICD-10 CM Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.cmCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`proProject_cmCodes_${scope.$index} details`" @click="buildPivotData('ICD-10 CM Codes', scope.row.dxNoRec, scope.row.dxAdditions, scope.row.dxDeletions, scope.row.dxRevisions, { table: 'proProject', prop: 'cmCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.cmCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccountsPRO.length">
            {{ getBedSizeValue('projectName', scope.row.projectName, 'cmCodes', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="emCodes" label="E/M Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('E/M Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.emCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`proProject_emCodes_${scope.$index} details`" @click="buildPivotData('E/M Codes', scope.row.emNoRec, scope.row.emAdditions, scope.row.emDeletions, scope.row.emRevisions, { table: 'proProject', prop: 'emCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.emCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccountsPRO.length">
            {{ getBedSizeValue('projectName', scope.row.projectName, 'emCodes', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="cptCodes" label="CPT Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('CPT Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.cptCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`proProject_cptCodes_${scope.$index} details`" @click="buildPivotData('CPT Codes', scope.row.cptNoRec, scope.row.cptAdditions, scope.row.cptDeletions, scope.row.cptRevisions, { table: 'proProject', prop: 'cptCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.cptCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccountsPRO.length">
            {{ getBedSizeValue('projectName', scope.row.projectName, 'cptCodes', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="modCodes" label="MOD Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('MOD Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.modCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`proProject_modCodes_${scope.$index} details`" @click="buildPivotData('MOD Codes', scope.row.modNoRec, scope.row.modAdditions, scope.row.modDeletions, scope.row.modRevisions, { table: 'proProject', prop: 'modCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.modCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccountsPRO.length">
            {{ getBedSizeValue('projectName', scope.row.projectName, 'modCodes', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="rvuDiff" label="RVU Impact" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('rvu', scope)">
            N/A
          </div>
          <div v-else v-html="highlightValue(`${scope.row.rvuDiff}`, filterCriteria)" :class="`proProject_rvuDiff_${scope.$index} details ${scope.row.rvuDiff < 0 ? 'negativeNumber' : ''}`" @click="buildPivotRVUData('RVU Impact', scope.row.originalWorkRvu, scope.row.recommendedWorkRvu, scope.row.rvuDiff, { table: 'proProject', prop: 'rvuDiff', index: scope.$index, row: scope.row }, $event, `${scope.row.rvuDiff}`)"></div>
          <div v-if="activateComparison && comparisonAccountsPRO.length" :class="`${getBedSizeValue('projectName', scope.row.projectName, 'rvuDiff', scope.row.codeDesc, true) < 0 ? 'negativeNumber' : ''}`">
            {{ getBedSizeValue('projectName', scope.row.projectName, 'rvuDiff', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-table ref="proHeaderReasonTable" v-if="grouping === '5'" key="proByHeaderReason" :data="isIE11 ? headerReasonTablePagniation : headerReasonTableData" empty-text="No Reason Data Available" :height="400" stripe :summary-method="getSummaries" show-summary>
      <el-table-column v-if="activateComparison && comparisonAccountsPRO.length" prop="changeReason" label=" " width="25">
        <template slot-scope="scope">
          <div>
            <i :title="`${currentClient} reviews`" style="float: left; font-size: 23px; margin: -1px 0px 0px -7px; color: rgba(19, 86, 149, .8);" :tag="scope.row.changeReason" class="mdi mdi-set-center"></i>
          </div>
          <div>
            <i title="All Profee reviews" style="float: left; font-size: 23px; margin: -2px 0px 0px -7px; color: rgba(236, 0, 140, 0.8);" class="mdi mdi-set-all"></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="changeReason" label="Reason" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.changeReason, filterCriteria)" :class="`proheaderreason_changeReason_${scope.$index} details`" @click="buildPivotDataStats('Reason Stats', scope.row.numRecords, scope.row.reimbIncreases, scope.row.reimbDecreases, scope.row.changeReason === 0 ? 0 : scope.row.numRecords, scope.row.originalWorkRvu, scope.row.recommendedWorkRvu, scope.row.rvuDiff, { table: 'proheaderreason', prop: 'changeReason', index: scope.$index, row: scope.row }, $event, scope.row.changeReason)"></div>
          <div v-if="activateComparison && comparisonAccountsPRO.length">
            {{ getBedSizeValue('changeDesc', scope.row.changeDesc, 'changeReason', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="changeDesc" label="Description" sortable>
        <template slot-scope="scope">
          <div>{{ scope.row.changeDesc }}</div>
          <div v-if="activateComparison && comparisonAccountsPRO.length">
            {{ getBedSizeValue('changeDesc', scope.row.changeDesc, 'changeDesc', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="numRecords" label="Total Instances" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.numRecords, filterCriteria)" title="View Account Numbers" class="details" @click="buildAccountNumbers(`Reason ${scope.row.changeReason}`, scope.row, $event)"></div>
          <div v-if="activateComparison && comparisonAccountsPRO.length">
            {{ getBedSizeValue('changeDesc', scope.row.changeDesc, 'numRecords', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="activateComparison" prop="numClients" label="# Clients">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.numClients, filterCriteria)"></div>
          <div v-if="activateComparison && comparisonAccountsPRO.length">
            {{ getBedSizeValue('changeDesc', scope.row.changeDesc, 'numClients', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="rvuDiff" label="RVU Impact" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('rvu', scope)">
            N/A
          </div>
          <div v-else v-html="highlightValue(`${scope.row.rvuDiff}`, filterCriteria)" :class="`proheaderreason_rvuDiff_${scope.$index} details ${scope.row.rvuDiff < 0 ? 'negativeNumber' : ''}`" @click="buildPivotRVUData('RVU Impact', scope.row.originalWorkRvu, scope.row.recommendedWorkRvu, scope.row.rvuDiff, { table: 'proheaderreason', prop: 'rvuDiff', index: scope.$index, row: scope.row }, $event, `${scope.row.rvuDiff}`)"></div>
          <div v-if="activateComparison && comparisonAccountsPRO.length" :class="`${getBedSizeValue('changeDesc', scope.row.changeDesc, 'rvuDiff', scope.row.codeDesc, true) < 0 ? 'negativeNumber' : ''}`">
            {{ getBedSizeValue('changeDesc', scope.row.changeDesc, 'rvuDiff', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-table class="tableNoWrap" ref="proDxTable" v-if="grouping === '6'" key="proByDx" :data="isIE11 || isCodeGrouping() ? dxTablePagination : dxTableData" empty-text="No Dx Data Available" :height="400" stripe :summary-method="getSummaries" show-summary @sort-change="handleSortChange">
      <el-table-column v-if="activateComparison && comparisonAccountsPRO.length" prop="code" label=" " width="25">
        <template slot-scope="scope">
          <div>
            <i :title="`${currentClient} reviews`" style="float: left; font-size: 23px; margin: -1px 0px 0px -7px; color: rgba(19, 86, 149, .8);" :tag="scope.row.code" class="mdi mdi-set-center"></i>
          </div>
          <div>
            <i title="All Profee reviews" style="float: left; font-size: 23px; margin: -2px 0px 0px -7px; color: rgba(236, 0, 140, 0.8);" class="mdi mdi-set-all"></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="codeDesc" label="Code Type" sortable="custom">
        <template slot-scope="scope">
          <div :title="scope.row.codeDesc" v-html="highlightValue(scope.row.codeDesc, filterCriteria)"></div>
          <div :title="scope.row.codeDesc" v-if="activateComparison && comparisonAccountsPRO.length">
            {{ getBedSizeValue('code', scope.row.code, 'codeDesc', scope.row.codeDesc, true, null, 'dx') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="code" label="Code" sortable="custom">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.code, filterCriteria)"></div>
          <div v-if="activateComparison && comparisonAccountsPRO.length">
            {{ getBedSizeValue('code', scope.row.code, 'code', scope.row.codeDesc, true, null, 'dx') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="description" label="Description" sortable="custom">
        <template slot-scope="scope">
          <div tag="description" :title="scope.row.description" v-html="highlightValue(scope.row.description, filterCriteria)"></div>
          <div tag="description" v-if="activateComparison && comparisonAccountsPRO.length">
            {{ getBedSizeValue('code', scope.row.code, 'description', scope.row.codeDesc, true, null, 'dx') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="totalRecords" label="Total Instances" sortable="custom">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.totalRecords, filterCriteria)" title="View Account Numbers" class="details" @click="buildAccountNumbers(`Dx Code ${scope.row.code}`, scope.row, $event)"></div>
          <div v-if="activateComparison && comparisonAccountsPRO.length">
            {{ getBedSizeValue('code', scope.row.code, 'totalRecords', scope.row.codeDesc, true, null, 'dx') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="activateComparison" prop="numClients" label="# Clients">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.numClients, filterCriteria)"></div>
          <div v-if="activateComparison && comparisonAccountsPRO.length">
            {{ getBedSizeValue('code', scope.row.code, 'numClients', scope.row.codeDesc, true, null, 'dx') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="accuracyRate" label="Accuracy Rate" sortable="custom">
        <template slot-scope="scope">
          <div v-if="checkPercentValues('dx cmCodes', scope)">
            N/A
          </div>
          <div v-else v-html="highlightValue(`${(scope.row.accuracyRate * 100).toFixed(2)}%`, filterCriteria)" :class="`prodx_accuracyRate_${scope.$index} details`" @click="buildPivotData('Dx Accuracy Rate', scope.row.numOfNoRec, scope.row.numOfAdditions, scope.row.numOfDeletions, scope.row.numOfRevisions, { table: 'prodx', prop: 'cmCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.accuracyRate * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccountsPRO.length">
            {{ getBedSizeValue('code', scope.row.code, 'accuracyRate', scope.row.codeDesc, true, null, 'dx') }}
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-table class="tableNoWrap" ref="proSdohTable" v-if="grouping === '13' || grouping === '18'" :key="grouping === '18' ? 'proPriDx' : 'proSdohDx'" :data="isIE11 || isCodeGrouping() ? sdohTablePagination : sdohTableData" :empty-text="grouping === '18' ? 'No Pri Dx Data Available' : 'No SDOH Dx Data Available'" :height="400" stripe :summary-method="getSummaries" show-summary @sort-change="handleSortChange">
      <el-table-column v-if="activateComparison && comparisonAccountsPRO.length" prop="code" label=" " width="25">
        <template slot-scope="scope">
          <div>
            <i :title="`${currentClient} reviews`" style="float: left; font-size: 23px; margin: -1px 0px 0px -7px; color: rgba(19, 86, 149, .8);" :tag="scope.row.code" class="mdi mdi-set-center"></i>
          </div>
          <div>
            <i title="All Profee reviews" style="float: left; font-size: 23px; margin: -2px 0px 0px -7px; color: rgba(236, 0, 140, 0.8);" class="mdi mdi-set-all"></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="codeDesc" label="Code Type" sortable="custom">
        <template slot-scope="scope">
          <div :title="scope.row.codeDesc" v-html="highlightValue(scope.row.codeDesc, filterCriteria)"></div>
          <div :title="scope.row.codeDesc" v-if="activateComparison && comparisonAccountsPRO.length">
            {{ getBedSizeValue('code', scope.row.code, 'codeDesc', scope.row.codeDesc, true, null, 'sdoh') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="code" label="Code" sortable="custom">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.code, filterCriteria)"></div>
          <div v-if="activateComparison && comparisonAccountsPRO.length">
            {{ getBedSizeValue('code', scope.row.code, 'code', scope.row.codeDesc, true, null, 'sdoh') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="description" label="Description" sortable="custom">
        <template slot-scope="scope">
          <div tag="description" :title="scope.row.description" v-html="highlightValue(scope.row.description, filterCriteria)"></div>
          <div tag="description" v-if="activateComparison && comparisonAccountsPRO.length">
            {{ getBedSizeValue('code', scope.row.code, 'description', scope.row.codeDesc, true, null, 'sdoh') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="totalRecords" label="Total Instances" sortable="custom">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.totalRecords, filterCriteria)" title="View Account Numbers" class="details" @click="buildAccountNumbers(`${grouping === '18' ? 'Pri Dx' : 'Dx SDOH'} Code ${scope.row.code}`, scope.row, $event)"></div>
          <div v-if="activateComparison && comparisonAccountsPRO.length">
            {{ getBedSizeValue('code', scope.row.code, 'totalRecords', scope.row.codeDesc, true, null, 'sdoh') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="activateComparison" prop="numClients" label="# Clients">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.numClients, filterCriteria)"></div>
          <div v-if="activateComparison && comparisonAccountsPRO.length">
            {{ getBedSizeValue('code', scope.row.code, 'numClients', scope.row.codeDesc, true, null, 'sdoh') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="accuracyRate" label="Accuracy Rate" sortable="custom">
        <template slot-scope="scope">
          <div v-if="checkPercentValues('dx cmCodes', scope)">
            N/A
          </div>
          <div v-else v-html="highlightValue(`${(scope.row.accuracyRate * 100).toFixed(2)}%`, filterCriteria)" :class="`prodx_accuracyRate_${scope.$index} details`" @click="buildPivotData(grouping === '18' ? 'Pri Dx Accuracy Rate' : 'SDOH Dx Accuracy Rate', scope.row.numOfNoRec, scope.row.numOfAdditions, scope.row.numOfDeletions, grouping === '18' ? priDxRevisionCount(scope.row) : scope.row.numOfRevisions, { table: 'prosdoh', prop: 'cmCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.accuracyRate * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccountsPRO.length">
            {{ getBedSizeValue('code', scope.row.code, 'accuracyRate', scope.row.codeDesc, true, null, 'sdoh') }}
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-table class="tableNoWrap" ref="proHccTable" v-if="grouping === '10'" key="proByHcc" :data="isIE11 || isCodeGrouping() ? hccTablePagination : hccTableData" empty-text="No HCC V24 Data Available" :height="400" stripe :summary-method="getSummaries" show-summary @sort-change="handleSortChange">
      <el-table-column v-if="activateComparison && comparisonAccountsPRO.length" prop="code" label=" " width="25">
        <template slot-scope="scope">
          <div>
            <i :title="`${currentClient} reviews`" style="float: left; font-size: 23px; margin: -1px 0px 0px -7px; color: rgba(19, 86, 149, .8);" :tag="scope.row.code" class="mdi mdi-set-center"></i>
          </div>
          <div>
            <i title="All Profee reviews" style="float: left; font-size: 23px; margin: -2px 0px 0px -7px; color: rgba(236, 0, 140, 0.8);" class="mdi mdi-set-all"></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="codeDesc" label="Code Type" sortable="custom">
        <template slot-scope="scope">
          <div :title="scope.row.codeDesc" v-html="highlightValue(scope.row.codeDesc, filterCriteria)"></div>
          <div :title="scope.row.codeDesc" v-if="activateComparison && comparisonAccountsPRO.length">
            {{ getBedSizeValue('code', scope.row.code, 'codeDesc', scope.row.codeDesc, true, null, 'hcc') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="code" label="HCC" sortable="custom">
        <template slot-scope="scope">
          <div class="details" v-html="highlightValue(scope.row.code, filterCriteria)" @click="buildDxPopover(`${scope.row.description}`, scope.row, $event, 'HCCV24')"></div>
          <div v-if="activateComparison && comparisonAccountsPRO.length">
            {{ getBedSizeValue('code', scope.row.code, 'code', scope.row.codeDesc, true, null, 'hcc') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="description" label="Description" sortable="custom">
        <template slot-scope="scope">
          <div tag="description" :title="scope.row.description" v-html="highlightValue(scope.row.description, filterCriteria)"></div>
          <div tag="description" v-if="activateComparison && comparisonAccountsPRO.length">
            {{ getBedSizeValue('code', scope.row.code, 'description', scope.row.codeDesc, true, null, 'hcc') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="totalRecords" label="Total Instances" sortable="custom">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.totalRecords, filterCriteria)" title="View Account Numbers" class="details" @click="buildAccountNumbers(`Dx Code ${scope.row.code}`, scope.row, $event)"></div>
          <div v-if="activateComparison && comparisonAccountsPRO.length">
            {{ getBedSizeValue('code', scope.row.code, 'totalRecords', scope.row.codeDesc, true, null, 'hcc') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="activateComparison" prop="numClients" label="# Clients">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.numClients, filterCriteria)"></div>
          <div v-if="activateComparison && comparisonAccountsPRO.length">
            {{ getBedSizeValue('code', scope.row.code, 'numClients', scope.row.codeDesc, true, null, 'hcc') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="accuracyRate" label="Accuracy Rate" sortable="custom">
        <template slot-scope="scope">
          <div v-if="checkPercentValues('dx cmCodes', scope)">
            N/A
          </div>
          <div v-else v-html="highlightValue(`${(scope.row.accuracyRate * 100).toFixed(2)}%`, filterCriteria)" :class="`prohcc_accuracyRate_${scope.$index} details`" @click="buildPivotData('HCC V24 Accuracy Rate', scope.row.numOfNoRec, scope.row.numOfAdditions, scope.row.numOfDeletions, scope.row.numOfRevisions, { table: 'prohcc', prop: 'hccV24AccuracyRate', index: scope.$index, row: scope.row }, $event, `${(scope.row.accuracyRate * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccountsPRO.length">
            {{ getBedSizeValue('code', scope.row.code, 'accuracyRate', scope.row.codeDesc, true, null, 'hcc') }}
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-table class="tableNoWrap" ref="proHccV28Table" v-if="grouping === '12'" key="proByHccV28" :data="isIE11 || isCodeGrouping() ? hccV28TablePagination : hccV28TableData" empty-text="No HCC V28 Data Available" :height="400" stripe :summary-method="getSummaries" show-summary @sort-change="handleSortChange">
      <el-table-column v-if="activateComparison && comparisonAccountsPRO.length" prop="code" label=" " width="25">
        <template slot-scope="scope">
          <div>
            <i :title="`${currentClient} reviews`" style="float: left; font-size: 23px; margin: -1px 0px 0px -7px; color: rgba(19, 86, 149, .8);" :tag="scope.row.code" class="mdi mdi-set-center"></i>
          </div>
          <div>
            <i title="All Profee reviews" style="float: left; font-size: 23px; margin: -2px 0px 0px -7px; color: rgba(236, 0, 140, 0.8);" class="mdi mdi-set-all"></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="codeDesc" label="Code Type" sortable="custom">
        <template slot-scope="scope">
          <div :title="scope.row.codeDesc" v-html="highlightValue(scope.row.codeDesc, filterCriteria)"></div>
          <div :title="scope.row.codeDesc" v-if="activateComparison && comparisonAccountsPRO.length">
            {{ getBedSizeValue('code', scope.row.code, 'codeDesc', scope.row.codeDesc, true, null, 'hccv28') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="code" label="HCC" sortable="custom">
        <template slot-scope="scope">
          <div class="details" v-html="highlightValue(scope.row.code, filterCriteria)" @click="buildDxPopover(`${scope.row.description}`, scope.row, $event, 'HCCV28')"></div>
          <div v-if="activateComparison && comparisonAccountsPRO.length">
            {{ getBedSizeValue('code', scope.row.code, 'code', scope.row.codeDesc, true, null, 'hccv28') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="description" label="Description" sortable="custom">
        <template slot-scope="scope">
          <div tag="description" :title="scope.row.description" v-html="highlightValue(scope.row.description, filterCriteria)"></div>
          <div tag="description" v-if="activateComparison && comparisonAccountsPRO.length">
            {{ getBedSizeValue('code', scope.row.code, 'description', scope.row.codeDesc, true, null, 'hccv28') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="totalRecords" label="Total Instances" sortable="custom">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.totalRecords, filterCriteria)" title="View Account Numbers" class="details" @click="buildAccountNumbers(`Dx Code ${scope.row.code}`, scope.row, $event)"></div>
          <div v-if="activateComparison && comparisonAccountsPRO.length">
            {{ getBedSizeValue('code', scope.row.code, 'totalRecords', scope.row.codeDesc, true, null, 'hccv28') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="activateComparison" prop="numClients" label="# Clients">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.numClients, filterCriteria)"></div>
          <div v-if="activateComparison && comparisonAccountsPRO.length">
            {{ getBedSizeValue('code', scope.row.code, 'numClients', scope.row.codeDesc, true, null, 'hccv28') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="accuracyRate" label="Accuracy Rate" sortable="custom">
        <template slot-scope="scope">
          <div v-if="checkPercentValues('dx cmCodes', scope)">
            N/A
          </div>
          <div v-else v-html="highlightValue(`${(scope.row.accuracyRate * 100).toFixed(2)}%`, filterCriteria)" :class="`prohccv28_accuracyRate_${scope.$index} details`" @click="buildPivotData('HCC V28 Accuracy Rate', scope.row.numOfNoRec, scope.row.numOfAdditions, scope.row.numOfDeletions, scope.row.numOfRevisions, { table: 'prohccv28', prop: 'hccV28AccuracyRate', index: scope.$index, row: scope.row }, $event, `${(scope.row.accuracyRate * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccountsPRO.length">
            {{ getBedSizeValue('code', scope.row.code, 'accuracyRate', scope.row.codeDesc, true, null, 'hccv28') }}
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-table class="tableNoWrap" ref="proCptTable" v-if="grouping === '7'" key="proByCpt" :data="isIE11 || isCodeGrouping() ? cptTablePagination : cptTableData" empty-text="No CPT Data Available" :height="400" stripe :summary-method="getSummaries" show-summary @sort-change="handleSortChange">
      <el-table-column v-if="activateComparison && comparisonAccountsPRO.length" prop="code" label=" " width="25">
        <template slot-scope="scope">
          <div>
            <i :title="`${currentClient} reviews`" style="float: left; font-size: 23px; margin: -1px 0px 0px -7px; color: rgba(19, 86, 149, .8);" :tag="scope.row.code" class="mdi mdi-set-center"></i>
          </div>
          <div>
            <i title="All Profee reviews" style="float: left; font-size: 23px; margin: -2px 0px 0px -7px; color: rgba(236, 0, 140, 0.8);" class="mdi mdi-set-all"></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="codeDesc" label="Code Type" sortable="custom">
        <template slot-scope="scope">
          <div :title="scope.row.codeDesc" v-html="highlightValue(scope.row.codeDesc, filterCriteria)"></div>
          <div :title="scope.row.codeDesc" v-if="activateComparison && comparisonAccountsPRO.length">
            {{ getBedSizeValue('code', scope.row.code, 'codeDesc', scope.row.codeDesc, true, null, 'cpt') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="code" label="Code" sortable="custom">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.code, filterCriteria)"></div>
          <div v-if="activateComparison && comparisonAccountsPRO.length">
            {{ getBedSizeValue('code', scope.row.code, 'code', scope.row.codeDesc, true, null, 'cpt') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="description" label="Description" sortable="custom">
        <template slot-scope="scope">
          <div tag="description" :title="scope.row.description" v-html="highlightValue(scope.row.description, filterCriteria)"></div>

          <div tag="description" v-if="activateComparison && comparisonAccountsPRO.length">
            {{ getBedSizeValue('code', scope.row.code, 'description', scope.row.codeDesc, true, null, 'cpt') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="totalRecords" label="Total Instances" sortable="custom">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.totalRecords, filterCriteria)" title="View Account Numbers" class="details" @click="buildAccountNumbers(`CPT Code ${scope.row.code}`, scope.row, $event)"></div>
          <div v-if="activateComparison && comparisonAccountsPRO.length">
            {{ getBedSizeValue('code', scope.row.code, 'totalRecords', scope.row.codeDesc, true, null, 'cpt') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="activateComparison" prop="numClients" label="# Clients">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.numClients, filterCriteria)"></div>
          <div v-if="activateComparison && comparisonAccountsPRO.length">
            {{ getBedSizeValue('code', scope.row.code, 'numClients', scope.row.codeDesc, true, null, 'cpt') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="accuracyRate" label="Accuracy Rate" sortable="custom">
        <template slot-scope="scope">
          <div v-if="checkPercentValues('dx cmCodes', scope)">
            N/A
          </div>
          <div v-else v-html="highlightValue(`${(scope.row.accuracyRate * 100).toFixed(2)}%`, filterCriteria)" :class="`procpt_accuracyRate_${scope.$index} details`" @click="buildPivotData('CPT Accuracy Rate', scope.row.numOfNoRec, scope.row.numOfAdditions, scope.row.numOfDeletions, scope.row.numOfRevisions, { table: 'procpt', prop: 'cptCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.accuracyRate * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccountsPRO.length">
            {{ getBedSizeValue('code', scope.row.code, 'accuracyRate', scope.row.codeDesc, true, null, 'cpt') }}
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-table class="tableNoWrap" ref="proModTable" v-if="grouping === '8'" key="proByMod" :data="isIE11 || isCodeGrouping() ? modTablePagination : modTableData" empty-text="No MOD Data Available" :height="400" stripe :summary-method="getSummaries" show-summary @sort-change="handleSortChange">
      <el-table-column v-if="activateComparison && comparisonAccountsPRO.length" prop="code" label=" " width="25">
        <template slot-scope="scope">
          <div>
            <i :title="`${currentClient} reviews`" style="float: left; font-size: 23px; margin: -1px 0px 0px -7px; color: rgba(19, 86, 149, .8);" :tag="scope.row.code" class="mdi mdi-set-center"></i>
          </div>
          <div>
            <i title="All Profee reviews" style="float: left; font-size: 23px; margin: -2px 0px 0px -7px; color: rgba(236, 0, 140, 0.8);" class="mdi mdi-set-all"></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="codeDesc" label="Code Type" sortable="custom">
        <template slot-scope="scope">
          <div :title="scope.row.codeDesc" v-html="highlightValue(scope.row.codeDesc, filterCriteria)"></div>
          <div :title="scope.row.codeDesc" v-if="activateComparison && comparisonAccountsPRO.length">
            {{ getBedSizeValue('code', scope.row.code, 'codeDesc', scope.row.codeDesc, true, null, 'mod') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="code" label="Code" sortable="custom">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.code, filterCriteria)"></div>
          <div v-if="activateComparison && comparisonAccountsPRO.length">
            {{ getBedSizeValue('code', scope.row.code, 'code', scope.row.codeDesc, true, null, 'mod') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="description" label="Description" sortable="custom">
        <template slot-scope="scope">
          <div tag="description" :title="scope.row.description" v-html="highlightValue(scope.row.description, filterCriteria)"></div>
          <div tag="description" v-if="activateComparison && comparisonAccountsPRO.length">
            {{ getBedSizeValue('code', scope.row.code, 'description', scope.row.codeDesc, true, null, 'mod') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="totalRecords" label="Total Instances" sortable="custom">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.totalRecords, filterCriteria)" title="View Account Numbers" class="details" @click="buildAccountNumbers(`MOD Code ${scope.row.code}`, scope.row, $event)"></div>
          <div v-if="activateComparison && comparisonAccountsPRO.length">
            {{ getBedSizeValue('code', scope.row.code, 'totalRecords', scope.row.codeDesc, true, null, 'mod') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="activateComparison" prop="numClients" label="# Clients">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.numClients, filterCriteria)"></div>
          <div v-if="activateComparison && comparisonAccountsPRO.length">
            {{ getBedSizeValue('code', scope.row.code, 'numClients', scope.row.codeDesc, true, null, 'mod') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="accuracyRate" label="Accuracy Rate" sortable="custom">
        <template slot-scope="scope">
          <div v-if="checkPercentValues('dx cmCodes', scope)">
            N/A
          </div>
          <div v-else v-html="highlightValue(`${(scope.row.accuracyRate * 100).toFixed(2)}%`, filterCriteria)" :class="`promod_accuracyRate_${scope.$index} details`" @click="buildPivotData('MOD Accuracy Rate', scope.row.numOfNoRec, scope.row.numOfAdditions, scope.row.numOfDeletions, scope.row.numOfRevisions, { table: 'promod', prop: 'modCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.accuracyRate * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccountsPRO.length">
            {{ getBedSizeValue('code', scope.row.code, 'accuracyRate', scope.row.codeDesc, true, null, 'mod') }}
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-table class="tableNoWrap" ref="proEmTable" v-if="grouping === '9'" key="proByEM" :data="isIE11 || isCodeGrouping() ? emTablePagination : emTableData" empty-text="No E/M Data Available" :height="400" stripe :summary-method="getSummaries" show-summary @sort-change="handleSortChange">
      <el-table-column v-if="activateComparison && comparisonAccountsPRO.length" prop="code" label=" " width="25">
        <template slot-scope="scope">
          <div>
            <i :title="`${currentClient} reviews`" style="float: left; font-size: 23px; margin: -1px 0px 0px -7px; color: rgba(19, 86, 149, .8);" :tag="scope.row.code" class="mdi mdi-set-center"></i>
          </div>
          <div>
            <i title="All Profee reviews" style="float: left; font-size: 23px; margin: -2px 0px 0px -7px; color: rgba(236, 0, 140, 0.8);" class="mdi mdi-set-all"></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="codeDesc" label="Code Type" sortable="custom">
        <template slot-scope="scope">
          <div :title="scope.row.codeDesc" v-html="highlightValue(scope.row.codeDesc, filterCriteria)"></div>
          <div :title="scope.row.codeDesc" v-if="activateComparison && comparisonAccountsPRO.length">
            {{ getBedSizeValue('code', scope.row.code, 'codeDesc', scope.row.codeDesc, true, null, 'em') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="code" label="Code" sortable="custom">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.code, filterCriteria)"></div>
          <div v-if="activateComparison && comparisonAccountsPRO.length">
            {{ getBedSizeValue('code', scope.row.code, 'code', scope.row.codeDesc, true, null, 'em') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="description" label="Description" sortable="custom">
        <template slot-scope="scope">
          <div tag="description" :title="scope.row.description" v-html="highlightValue(scope.row.description, filterCriteria)"></div>
          <div tag="description" v-if="activateComparison && comparisonAccountsPRO.length">
            {{ getBedSizeValue('code', scope.row.code, 'description', scope.row.codeDesc, true, null, 'em') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="totalRecords" label="Total Instances" sortable="custom">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.totalRecords, filterCriteria)" title="View Account Numbers" class="details" @click="buildAccountNumbers(`E/M Code ${scope.row.code}`, scope.row, $event)"></div>
          <div v-if="activateComparison && comparisonAccountsPRO.length">
            {{ getBedSizeValue('code', scope.row.code, 'totalRecords', scope.row.codeDesc, true, null, 'em') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="activateComparison" prop="numClients" label="# Clients">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.numClients, filterCriteria)"></div>
          <div v-if="activateComparison && comparisonAccountsPRO.length">
            {{ getBedSizeValue('code', scope.row.code, 'numClients', scope.row.codeDesc, true, null, 'em') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="accuracyRate" label="Accuracy Rate" sortable="custom">
        <template slot-scope="scope">
          <div v-if="checkPercentValues('dx cmCodes', scope)">
            N/A
          </div>
          <div v-else v-html="highlightValue(`${(scope.row.accuracyRate * 100).toFixed(2)}%`, filterCriteria)" :class="`proem_accuracyRate_${scope.$index} details`" @click="buildPivotData('E/M Accuracy Rate', scope.row.numOfNoRec, scope.row.numOfAdditions, scope.row.numOfDeletions, scope.row.numOfRevisions, { table: 'proem', prop: 'cptCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.accuracyRate * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccountsPRO.length">
            {{ getBedSizeValue('code', scope.row.code, 'accuracyRate', scope.row.codeDesc, true, null, 'em') }}
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-table ref="proEMLevelSummaryTable" v-if="grouping === '11'" key="proEMLevel" :data="isIE11 ? emLevelSummaryPagination : emLevelSummaryData" :fit="true" empty-text="No EM Summary Data Available" :height="400" show-summary stripe :summary-method="getSummaries">
      <el-table-column v-if="activateComparison && comparisonAccountsPRO.length" prop="codeDesc" label=" " width="25">
        <template slot-scope="scope">
          <div>
            <i :title="`${currentClient} reviews`" style="float: left; font-size: 23px; margin: -1px 0px 0px -7px; color: rgba(19, 86, 149, .8);" :tag="scope.row.codeDesc" class="mdi mdi-set-center"></i>
          </div>
          <div>
            <i title="All Profee reviews" style="float: left; font-size: 23px; margin: -2px 0px 0px -7px; color: rgba(236, 0, 140, 0.8);" class="mdi mdi-set-all"></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="codeDesc" label="Code Type" sortable>
        <template slot-scope="scope">
          <div :title="scope.row.codeDesc">{{ scope.row.codeDesc }}</div>

          <div :title="scope.row.codeDesc" v-if="activateComparison && comparisonAccountsPRO.length">
            {{ getBedSizeValue('reason', scope.row.reason, 'codeDesc', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="reason" label="Reason" sortable>
        <template slot-scope="scope">
          <div :title="scope.row.reason" v-html="highlightValue(scope.row.reason, filterCriteria)" :class="`proemLevelSumm_reason_${scope.$index} details`" @click="buildPivotDataStats('EM Change Stats', scope.row.number, 0, 0, scope.row.number, scope.row.originalWorkRvu, scope.row.recommendedWorkRvu, scope.row.rvuDiff, { table: 'proemLevelSumm', prop: 'reason', index: scope.$index, row: scope.row }, $event, scope.row.reason)"></div>
          <div :title="scope.row.reason" v-if="activateComparison && comparisonAccountsPRO.length">
            {{ getBedSizeValue('reason', scope.row.reason, 'reason', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="number" label="Total Instances" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.number, filterCriteria)" title="View Account Numbers" class="details" @click="buildAccountNumbers(`EM Change ${scope.row.reason}`, scope.row, $event)"></div>
          <div v-if="activateComparison && comparisonAccountsPRO.length">
            {{ getBedSizeValue('reason', scope.row.reason, 'number', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="rvuDiff" label="RVU Impact" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('rvu', scope)">
            N/A
          </div>
          <div v-else v-html="highlightValue(`${scope.row.rvuDiff}`, filterCriteria)" :class="`proemLevelSumm_rvuDiff_${scope.$index} details ${scope.row.rvuDiff < 0 ? 'negativeNumber' : ''}`" @click="buildPivotRVUData('RVU Impact', scope.row.originalWorkRvu, scope.row.recommendedWorkRvu, scope.row.rvuDiff, { table: 'proemLevelSumm', prop: 'rvuDiff', index: scope.$index, row: scope.row }, $event, `${scope.row.rvuDiff}`)"></div>
          <div v-if="activateComparison && comparisonAccountsPRO.length" :class="`${getBedSizeValue('reason', scope.row.reason, 'rvuDiff', scope.row.codeDesc, true) < 0 ? 'negativeNumber' : ''}`">
            {{ getBedSizeValue('reason', scope.row.reason, 'rvuDiff', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-table ref="proServiceLineTable" v-if="grouping === '16'" key="proByServiceLine" :data="isIE11 ? serviceLineTablePagination : serviceLineTableData" empty-text="No Service Line Data Available" :height="400" :summary-method="getSummaries" show-summary stripe>
      <el-table-column prop="codeDesc" label="Code Type" sortable> </el-table-column>
      <el-table-column prop="clientServiceLineName" label="Service Line" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.clientServiceLineName, filterCriteria)" :class="`proServiceLine_clientServiceLineName_${scope.$index} details`" @click="buildPivotDataStats('Service Line Stats', scope.row.totalRecords, scope.row.reimbInc, scope.row.reimbDec, scope.row.recordsWithRecommendations, scope.row.originalWorkRvu, scope.row.recommendedWorkRvu, scope.row.rvuDiff, { table: 'proServiceLine', prop: 'clientServiceLineName', index: scope.$index, row: scope.row }, $event, scope.row.clientServiceLineName)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="totalRecords" label="Total Instances" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.totalRecords, filterCriteria)" title="View Account Numbers" class="details" @click="buildAccountNumbers(`Service Line ${scope.row.clientServiceLineName}`, scope.row, $event)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="totalCodes" label="Total Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('Total Codes', scope, null)">N/A</div>
          <div v-if="scope.row.totalCodes" v-html="highlightValue(`${(scope.row.totalCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`proServiceLine_totalCodes_${scope.$index} details`" @click="buildPivotData('Total Codes', scope.row.dxNoRec + scope.row.emNoRec + scope.row.cptNoRec + scope.row.modNoRec, scope.row.dxAdditions + scope.row.emAdditions + scope.row.cptAdditions + scope.row.modAdditions, scope.row.dxDeletions + scope.row.emDeletions + scope.row.cptDeletions + scope.row.modDeletions, scope.row.dxRevisions + scope.row.emRevisions + scope.row.cptRevisions + scope.row.modRevisions, { table: 'proServiceLine', prop: 'proTotalCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.totalCodes * 100).toFixed(2)}%`)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="cmCodes" label="ICD-10 CM Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('ICD-10 CM Codes', scope, null)">
            N/A
          </div>
          <div v-else v-html="highlightValue(`${(scope.row.cmCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`proServiceLine_cmCodes_${scope.$index} details`" @click="buildPivotData('ICD-10 CM Codes', scope.row.dxNoRec, scope.row.dxAdditions, scope.row.dxDeletions, scope.row.dxRevisions, { table: 'proServiceLine', prop: 'cmCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.cmCodes * 100).toFixed(2)}%`)">
            {{ `${(scope.row.cmCodes * 100).toFixed(2)}%` }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="emCodes" label="E/M Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('E/M Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.emCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`proServiceLine_emCodes_${scope.$index} details`" @click="buildPivotData('E/M Codes', scope.row.emNoRec, scope.row.emAdditions, scope.row.emDeletions, scope.row.emRevisions, { table: 'proServiceLine', prop: 'emCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.emCodes * 100).toFixed(2)}%`)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="cptCodes" label="CPT Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('CPT Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.cptCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`proServiceLine_cptCodes_${scope.$index} details`" @click="buildPivotData('CPT Codes', scope.row.cptNoRec, scope.row.cptAdditions, scope.row.cptDeletions, scope.row.cptRevisions, { table: 'proServiceLine', prop: 'cptCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.cptCodes * 100).toFixed(2)}%`)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="modCodes" label="MOD Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('MOD Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.modCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`proServiceLine_modCodes_${scope.$index} details`" @click="buildPivotData('MOD Codes', scope.row.modNoRec, scope.row.modAdditions, scope.row.modDeletions, scope.row.modRevisions, { table: 'proServiceLine', prop: 'modCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.modCodes * 100).toFixed(2)}%`)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="rvuDiff" label="RVU Impact" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('rvu', scope)">
            N/A
          </div>
          <div v-else v-html="highlightValue(`${scope.row.rvuDiff}`, filterCriteria)" :class="`proServiceLine_rvuDiff_${scope.$index} details ${scope.row.rvuDiff < 0 ? 'negativeNumber' : ''}`" @click="buildPivotRVUData('RVU Impact', scope.row.originalWorkRvu, scope.row.recommendedWorkRvu, scope.row.rvuDiff, { table: 'proServiceLine', prop: 'rvuDiff', index: scope.$index, row: scope.row }, $event, `${scope.row.rvuDiff}`)"></div>
        </template>
      </el-table-column>
    </el-table>

    <div class="qmDisclaimer priDxDisclaimer" v-if="isPriDxGrouping()">Pri Dx revisions include both 'Revised From' and 'Revised To'. A single record can appear under two principal diagnoses, so the total instances can be higher than the number of unique records.</div>
    <el-pagination class="pager" v-if="isIE11" background :pager-count="15" layout="total, prev, pager, next" :page-size="itemsPerPage" :total="paginationTotal" @current-change="handleCurrentChange" :hide-on-single-page="hideOnSinglePage" small> </el-pagination>

    <el-pagination class="pager" v-if="isCodeGrouping()" background :pager-count="15" layout="total, prev, pager, next" :page-size="codeItemsPerPage" :total="paginationTotal" :current-page.sync="currentPage" @current-change="handleCurrentChange" :hide-on-single-page="hideOnSinglePage" small> </el-pagination>

    <el-popover ref="proDetailsPopOver" :visible-arrow="false" placement="bottom" width="400" trigger="click" @after-enter="handleHidePopOver">
      <DetailsPopOver :header="header" :popOverData="popOverData" :tableType="tableType" :reviewType="reviewType" :row="row" :rowMeta="rowMeta" :isOpen="isOpen" @tableTypeChange="handleTableTypeChange" @headerChange="header = $event"> </DetailsPopOver>
    </el-popover>
  </div>
</template>

<script>
import HiaAuthorization from '@/mixins/hiaAuthorization'
import money from '@/mixins/money'
import hiaFilters from '@/mixins/hiaFilters'
import DetailsPopOver from '@/views/Dashboards/DetailsPopOver'
import { shouldDismissDashboardPopover, patchPopoverDocumentClick } from '@/utilities/dashboardPopoverDismiss'
import { mapState, mapActions, mapMutations } from 'vuex'
import { format, parseISO } from 'date-fns'

export default {
  data: function() {
    return {
      header: '',
      popperClickTarget: undefined,
      popOverData: [],
      tableType: '',
      reviewType: 'pro',
      row: {},
      rowMeta: {},
      isOpen: false,
      currentPage: 1,
      itemsPerPage: 30,
      isIE11: !!navigator.userAgent.match(/Trident\/7\./),
      hideOnSinglePage: true,
      codeItemsPerPage: 60,
      sortProp: '',
      sortOrder: ''
    }
  },
  name: 'proTables',
  mixins: [HiaAuthorization, money, hiaFilters],
  props: {
    grouping: { type: String },
    codeTypeGrouping: { type: Array },
    dropdown: { type: Array },
    filterCriteria: { type: String },
    selectedGrouping: { type: Array },
    activateComparison: { type: Boolean },
    bedSize: { type: String }
  },
  components: {
    DetailsPopOver
  },
  methods: {
    ...mapActions('dashboard/', ['GET_DASHBOARD_PROJECTS']),
    ...mapMutations('dashboard/', ['CLEAR_DASHBOARD_ACCOUNTS']),
    handleTableTypeChange(newType) {
      this.tableType = newType
      if (newType === 'accountNumbers') {
        this.$nextTick(() => {
          this.$refs.proDetailsPopOver.$refs.popper.classList.add('largeCenterPopOver')
        })
      }
    },
    moneyFormatter(value) {
      return `$${this.formatMoney(value)}`
    },
    getTableData(grouping) {
      if (!this.reviewDashboardData) {
        return []
      }

      let proIndex = this.reviewDashboardData.findIndex(x => x.type === 'profee') > -1 ? this.reviewDashboardData.findIndex(x => x.type === 'profee') : null
      if (proIndex !== null && this.reviewDashboardData[proIndex].largeStats) {
        let groupIndex = this.reviewDashboardData[proIndex].largeStats.findIndex(x => x.title === grouping)
        let data = this.reviewDashboardData[proIndex].largeStats.some(x => x.title === grouping) ? this.reviewDashboardData[proIndex].largeStats[groupIndex].data : []

        if (this.filterCriteria.length) {
          data = this.filterList(data, this.filterCriteria)
        }

        if (this.codeTypeGrouping.length) {
          data = data.filter(x => {
            let val
            this.codeTypeGrouping.forEach(y => {
              if (x.codeDesc === y) {
                val = x
              }
            })
            return val
          })
        }

        if (this.selectedGrouping.length) {
          let groupKey = this.reviewDashboardData[proIndex].largeStats.some(x => x.title === grouping) ? this.reviewDashboardData[proIndex].largeStats[groupIndex].groupKey : ''
          data = data.filter(x => {
            let val
            this.selectedGrouping.forEach(y => {
              if (x[groupKey].toString() === y.toString()) {
                val = x
              }
            })
            return val
          })
        }

        return data
      }
      return []
    },
    buildPivotData(header, noRecs, adds, dels, revs, row, e, displayValue) {
      this.$nextTick(() => {
        this.tableType = 'stats'
        this.header = displayValue ? `${header} - ${displayValue}` : header
        this.popOverData = [{ title: 'Total Reviewed', value: noRecs + adds + dels + revs }, { title: 'Total Recommendations', value: adds + dels + revs }, { title: '', value: '' }, { title: 'No Recommendations', value: noRecs }, { title: 'Additions', value: adds }, { title: 'Deletions', value: dels }]
        // include revisions line for all except HCC
        if (!(row.table && (row.table === 'prohcc' || row.table === 'prohccv28'))) {
          this.popOverData.push({ title: 'Revisions', value: revs })
        }
        this.rowMeta = {
          table: row.table,
          prop: row.prop,
          codeNumber: row.row.codeNumber
        }
        this.row = row.row
        this.handleShowPopOver(row, e ? e.target : undefined)
      })
    },
    buildPivotDataStats(header, totalRecords, reimbInc, reimbDec, recordsWithRecommendations, originalWorkRvu, recommendedWorkRvu, rvuDiff, row, e, displayValue) {
      this.$nextTick(() => {
        this.tableType = 'proDataStats'
        this.header = displayValue ? `${header} - ${displayValue}` : header
        const roundRvu = v => (v == null || isNaN(v) ? v : Math.round(v * 100) / 100)
        this.popOverData = [{ title: 'Number of Records', value: totalRecords }, { title: 'Record Recommendations', value: recordsWithRecommendations }, { title: 'Original Work RVU', value: roundRvu(originalWorkRvu) }, { title: 'Recommended Work RVU', value: roundRvu(recommendedWorkRvu) }, { title: '', value: '' }, { title: 'RVU Difference', value: roundRvu(rvuDiff) }]
        this.rowMeta = {
          table: row.table,
          prop: 'mainDashboardGrouping',
          codeNumber: row.row.codeNumber
        }
        this.row = row.row
        this.handleShowPopOver(row, e ? e.target : undefined)
      })
    },
    buildPivotDataFinancials(header, financialImpact, reimbInc, reimbDec, reimbIncRecords, reimbDecRecords, row, e, displayValue) {
      this.$nextTick(() => {
        this.tableType = 'financial'
        this.header = displayValue ? `${header} - ${displayValue}` : header
        this.popOverData = [{ title: 'Financial Impact', value: financialImpact }, { title: 'Reimbursement Decrease', value: reimbDec }, { title: 'Reimbursement Increase', value: reimbInc }, { title: 'Reimbursement Decrease Records', value: reimbDecRecords }, { title: 'Reimbursement Increase Records', value: reimbIncRecords }]
        this.rowMeta = {
          table: row.table,
          prop: row.prop,
          codeNumber: row.row.codeNumber
        }
        this.row = row.row
        this.handleShowPopOver(row, e ? e.target : undefined)
      })
    },
    buildDxPopover(title, row, e, hccVersion) {
      this.clearPopOverData()
      this.$nextTick(() => {
        this.tableType = 'dxDashboard'
        this.header = `HCC ${title}`
        this.popOverData = []
        this.row = row
        this.row.hccVersion = hccVersion
        this.handleShowDetailsPopover(e.target)
      })
    },
    buildAccountNumbers(title, row, e) {
      this.clearPopOverData()
      this.$nextTick(() => {
        this.tableType = 'accountNumbers'
        this.header = title
        this.popOverData = []
        this.row = row
        this.handleShowDetailsPopover(e.target)
      })
    },
    getSummaryData() {
      let data = this.isIE11 ? this.paginationSummaries : []
      if (this.isCodeGrouping()) {
        data = this.codeGroupingAllData
      }
      if (!data || !data.length) {
        switch (this.grouping) {
          case '1': data = this.coderTableData; break
          case '15': data = this.coderTrendingTableData; break
          case '2': data = this.providerTableData; break
          case '14': data = this.providerTrendingTableData; break
          case '3': data = this.patientTypeTableData; break
          case '4': data = this.facilityTableData; break
          case '17': data = this.projectTableData; break
          case '5': data = this.headerReasonTableData; break
          case '6': data = this.dxTableData; break
          case '13': data = this.sdohTableData; break
          case '18': data = this.sdohTableData; break
          case '10': data = this.hccTableData; break
          case '12': data = this.hccV28TableData; break
          case '7': data = this.cptTableData; break
          case '8': data = this.modTableData; break
          case '9': data = this.emTableData; break
          case '11': data = this.emLevelSummaryData; break
          case '16': data = this.serviceLineTableData; break
        }
      }
      return data || []
    },
    isPriDxGrouping() {
      return this.grouping === '18'
    },
    priDxRevisionCount(row) {
      const fromVal = row.numOfRevisedFrom != null ? row.numOfRevisedFrom : row.revisedFromCount
      const toVal = row.numOfRevisedTo != null ? row.numOfRevisedTo : row.revisedToCount
      const from = Number(fromVal)
      const to = Number(toVal)
      return (isNaN(from) ? 0 : from) + (isNaN(to) ? 0 : to)
    },
    buildSummaryPivotData(columnProperty, targetElement) {
      let data = this.getSummaryData()
      if (!data.length) return

      const sum = (field) => data.reduce((t, r) => t + (isNaN(Number(r[field])) ? 0 : r[field]), 0)
      let allAccountNumbers = data.map(r => r.accountNumbers).filter(a => a).join(',')
      const fakeRow = { table: 'summary', prop: columnProperty, row: { accountNumbers: allAccountNumbers } }

      switch (columnProperty) {
        case 'totalCodes': {
          let noRecs = sum('dxNoRec') + sum('emNoRec') + sum('cptNoRec') + sum('modNoRec')
          let adds = sum('dxAdditions') + sum('emAdditions') + sum('cptAdditions') + sum('modAdditions')
          let dels = sum('dxDeletions') + sum('emDeletions') + sum('cptDeletions') + sum('modDeletions')
          let revs = sum('dxRevisions') + sum('emRevisions') + sum('cptRevisions') + sum('modRevisions')
          let tcRow = { table: 'summary', prop: 'proTotalCodes', row: { accountNumbers: allAccountNumbers } }
          let displayValue = this.calculatePercentages(noRecs + adds + dels + revs, adds + dels + revs)
          this.buildPivotData('Total Codes', noRecs, adds, dels, revs, tcRow, { target: targetElement }, displayValue)
          break
        }
        case 'cmCodes': {
          let noRecs, adds, dels, revs, label
          if (this.grouping === '6' || this.grouping === '13' || this.grouping === '18') {
            noRecs = sum('numOfNoRec'); adds = sum('numOfAdditions'); dels = sum('numOfDeletions'); revs = this.isPriDxGrouping() ? data.reduce((t, r) => t + this.priDxRevisionCount(r), 0) : sum('numOfRevisions'); label = this.grouping === '18' ? 'Pri Dx Accuracy Rate' : this.grouping === '13' ? 'SDOH Dx Accuracy Rate' : 'Dx Accuracy Rate'
          } else {
            noRecs = sum('dxNoRec'); adds = sum('dxAdditions'); dels = sum('dxDeletions'); revs = sum('dxRevisions'); label = 'ICD-10 CM Codes'
          }
          let displayValue = this.calculatePercentages(noRecs + adds + dels + revs, adds + dels + revs)
          this.buildPivotData(label, noRecs, adds, dels, revs, fakeRow, { target: targetElement }, displayValue)
          break
        }
        case 'emCodes': {
          let noRecs, adds, dels, revs, label
          if (this.grouping === '9') {
            noRecs = sum('numOfNoRec'); adds = sum('numOfAdditions'); dels = sum('numOfDeletions'); revs = sum('numOfRevisions'); label = 'E/M Accuracy Rate'
          } else {
            noRecs = sum('emNoRec'); adds = sum('emAdditions'); dels = sum('emDeletions'); revs = sum('emRevisions'); label = 'E/M Codes'
          }
          let displayValue = this.calculatePercentages(noRecs + adds + dels + revs, adds + dels + revs)
          this.buildPivotData(label, noRecs, adds, dels, revs, fakeRow, { target: targetElement }, displayValue)
          break
        }
        case 'cptCodes': {
          let noRecs, adds, dels, revs, label
          if (this.grouping === '7') {
            noRecs = sum('numOfNoRec'); adds = sum('numOfAdditions'); dels = sum('numOfDeletions'); revs = sum('numOfRevisions'); label = 'CPT Accuracy Rate'
          } else {
            noRecs = sum('cptNoRec'); adds = sum('cptAdditions'); dels = sum('cptDeletions'); revs = sum('cptRevisions'); label = 'CPT Codes'
          }
          let displayValue = this.calculatePercentages(noRecs + adds + dels + revs, adds + dels + revs)
          this.buildPivotData(label, noRecs, adds, dels, revs, fakeRow, { target: targetElement }, displayValue)
          break
        }
        case 'modCodes': {
          let noRecs, adds, dels, revs, label
          if (this.grouping === '8') {
            noRecs = sum('numOfNoRec'); adds = sum('numOfAdditions'); dels = sum('numOfDeletions'); revs = sum('numOfRevisions'); label = 'MOD Accuracy Rate'
          } else {
            noRecs = sum('modNoRec'); adds = sum('modAdditions'); dels = sum('modDeletions'); revs = sum('modRevisions'); label = 'MOD Codes'
          }
          let displayValue = this.calculatePercentages(noRecs + adds + dels + revs, adds + dels + revs)
          this.buildPivotData(label, noRecs, adds, dels, revs, fakeRow, { target: targetElement }, displayValue)
          break
        }
        case 'accuracyRate': {
          let arDimension = 'hccV24AccuracyRate'
          let arLabel = 'HCC V24 Accuracy Rate'
          if (this.grouping === '12') {
            arDimension = 'hccV28AccuracyRate'
            arLabel = 'HCC V28 Accuracy Rate'
          } else if (this.grouping === '6') {
            arDimension = 'cmCodes'
            arLabel = 'Dx Accuracy Rate'
          } else if (this.grouping === '13' || this.grouping === '18') {
            arDimension = 'cmCodes'
            arLabel = this.grouping === '18' ? 'Pri Dx Accuracy Rate' : 'SDOH Dx Accuracy Rate'
          } else if (this.grouping === '7') {
            arDimension = 'cptCodes'
            arLabel = 'CPT Accuracy Rate'
          } else if (this.grouping === '9') {
            arDimension = 'cptCodes'
            arLabel = 'E/M Accuracy Rate'
          } else if (this.grouping === '8') {
            arDimension = 'modCodes'
            arLabel = 'MOD Accuracy Rate'
          }
          let arRow = { table: 'summary', prop: arDimension, row: { accountNumbers: allAccountNumbers } }
          let noRecs = sum('numOfNoRec'); let adds = sum('numOfAdditions'); let dels = sum('numOfDeletions'); let revs = sum('numOfRevisions')
          let displayValue = this.calculatePercentages(noRecs + adds + dels + revs, adds + dels + revs)
          this.buildPivotData(arLabel, noRecs, adds, dels, revs, arRow, { target: targetElement }, displayValue)
          break
        }
        case 'rvuDiff': {
          let rvuDiff = sum('rvuDiff')
          let displayValue = `${Math.round(rvuDiff * 100) / 100}`
          this.buildPivotRVUData('RVU Impact', sum('originalWorkRvu'), sum('recommendedWorkRvu'), rvuDiff, fakeRow, { target: targetElement }, displayValue)
          break
        }
      }
    },
    buildSummaryAccountNumbers(targetElement) {
      let data = this.getSummaryData()
      if (!data.length) return
      let allAccountNumbers = data
        .map(r => r.accountNumbers)
        .filter(a => a)
        .join(',')
      if (!allAccountNumbers) return
      let syntheticRow = { accountNumbers: allAccountNumbers }
      this.clearPopOverData()
      this.$nextTick(() => {
        this.tableType = 'accountNumbers'
        this.header = 'Total Instances'
        this.popOverData = []
        this.row = syntheticRow
        this.handleShowDetailsPopover(targetElement)
      })
    },
    getActiveTableRef() {
      const map = {
        '1': 'proCoderTable',
'15': 'proCoderTrendingTable',
'2': 'proProviderTable',
        '14': 'proProviderTrendingTable',
'3': 'proPatientTypeTable',
'4': 'proFacilityTable',
        '17': 'proProjectTable',
        '5': 'proHeaderReasonTable',
'6': 'proDxTable',
'13': 'proSdohTable',
'18': 'proSdohTable',
        '10': 'proHccTable',
'12': 'proHccV28Table',
'7': 'proCptTable',
        '8': 'proModTable',
'9': 'proEmTable',
'11': 'proEMLevelSummaryTable',
        '16': 'proServiceLineTable'
      }
      return map[this.grouping] || null
    },
    attachSummaryClickHandlers() {
      this.cleanupSummaryHandlers()

      let tableRef = this.getActiveTableRef()
      if (!tableRef || !this.$refs[tableRef]) return

      let tableEl = this.$refs[tableRef].$el
      let footerWrapper = tableEl.querySelector('.el-table__footer-wrapper')
      if (!footerWrapper) return

      let footerCells = footerWrapper.querySelectorAll('td')
      let table = this.$refs[tableRef]
      let columns = table.columns || []

      const clickableColumns = [
        'totalRecords', 'numRecords', 'number',
        'totalCodes', 'cmCodes', 'emCodes', 'cptCodes', 'modCodes',
        'accuracyRate', 'rvuDiff'
      ]

      footerCells.forEach((td, index) => {
        if (index >= columns.length) return
        let colProp = columns[index].property
        if (clickableColumns.includes(colProp)) {
          let cellText = td.textContent.trim()
          if (!cellText || cellText === 'N/A' || cellText === 'n/a' || cellText === '' || cellText === '—') return

          td.classList.add('details')
          let handler = (e) => {
            e.stopPropagation()
            if (colProp === 'totalRecords' || colProp === 'numRecords' || colProp === 'number') {
              this.buildSummaryAccountNumbers(td)
            } else {
              this.buildSummaryPivotData(colProp, td)
            }
          }
          td.addEventListener('click', handler)
          this._summaryHandlers.push({ el: td, handler: handler })
        }
      })
    },
    cleanupSummaryHandlers() {
      if (this._summaryHandlers) {
        this._summaryHandlers.forEach(({ el, handler }) => {
          el.removeEventListener('click', handler)
          el.classList.remove('details')
        })
      }
      this._summaryHandlers = []
    },
    buildPivotRVUData(header, originalWorkRvu, recommendedWorkRvu, rvuDiff, row, e, displayValue) {
      this.$nextTick(() => {
        this.tableType = 'stats'
        const roundRvu = v => (v == null || isNaN(v) ? v : Math.round(v * 100) / 100)
        this.header = displayValue != null && displayValue !== '' ? `${header} - ${displayValue}` : header
        this.popOverData = [{ title: 'Original Work RVU', value: roundRvu(originalWorkRvu) }, { title: 'Recommended Work RVU', value: roundRvu(recommendedWorkRvu) }, { title: '', value: '' }, { title: 'RVU Difference', value: roundRvu(rvuDiff) }]
        this.rowMeta = {
          table: row.table,
          prop: row.prop,
          codeNumber: row.row.codeNumber
        }
        this.row = row.row
        this.handleShowPopOver(row, e ? e.target : undefined)
      })
    },
    handleShowDetailsPopover(clickTarget) {
      let popper = this.$refs.proDetailsPopOver
      popper.doDestroy()
      popper.doClose()

      this.$nextTick(() => {
        this.popperClickTarget = clickTarget
        let reference = document.querySelector('#reviewDashboard')
        popper.doDestroy()
        popper.referenceElm = reference
        this.isOpen = true
        popper.$refs.popper.classList.add('largeCenterPopOver')
        popper.doShow()
        this.$nextTick(() => {
          this.$refs.proDetailsPopOver.$refs.popper.classList.add('largeCenterPopOver')
        })
      })
    },
    handleShowPopOver(row, targetElement) {
      let popper = this.$refs.proDetailsPopOver
      popper.doDestroy()
      popper.doClose()

      this.$nextTick(() => {
        this.popperClickTarget = targetElement || document.querySelector(`.${row.table}_${row.prop}_${row.index}`)
        popper.doDestroy()
        popper.referenceElm = this.popperClickTarget
        this.isOpen = true
        popper.doShow()
      })
    },
    handleHidePopOver() {
      let popper = this.$refs.proDetailsPopOver
      patchPopoverDocumentClick(popper)
      const handler = e => {
        if (shouldDismissDashboardPopover(e, popper, this.popperClickTarget)) {
          this.CLEAR_DASHBOARD_ACCOUNTS()
          this.isOpen = false
          popper.doClose()
          popper.doDestroy()
          this.clearClass()
          document.removeEventListener('click', handler, false)
        }
      }
      document.addEventListener('click', handler, false)
    },
    clearPopOverData() {
      this.CLEAR_DASHBOARD_ACCOUNTS()
      this.tableType = ''
      this.header = ''
      this.popOverData = []
      this.row = {}
      this.isOpen = false
    },
    clearClass() {
      let popper = this.$refs.proDetailsPopOver
      popper.$refs.popper.classList.remove('largeCenterPopOver')
    },
    getAPCSummary(param) {
      let { columns, data } = param
      const sums = []

      if (this.isIE11) {
        data = this.paginationSummaries
      }

      columns.forEach((column, index) => {
        switch (column.property) {
          case 'codeDesc':
            sums[index] = ''
            break
          case 'apc':
            sums[index] = ''
            break
          case 'patType':
            sums[index] = ''
            break
          case 'apcCodes':
            sums[index] = this.codeTypeGrouping.length === 1 ? this.totalAPCPercentSummary(column.property, data, index) : '—'
            break
          case 'financialImpact':
            let value = this.totalMoneySummary(column.property, data, index)
            let td = document.querySelector(`.el-table__footer .${column.id}`)
            if (td) {
              if (value.replace(/[$]|[,]/g, '') < 0 && this.codeTypeGrouping.length) {
                td.classList.add('negative_td')
              } else {
                td.classList.remove('negative_td')
              }
            }
            sums[index] = this.codeTypeGrouping.length === 1 ? value : '—'
            break
          default:
            sums[index] = 'n/a'
        }
      })

      return sums
    },
    getSummaries(param) {
      let { columns, data } = param
      const sums = []
      let value
      let td

      if (this.isIE11) {
        data = this.paginationSummaries
      }

      if (this.isCodeGrouping()) {
        data = this.codeGroupingAllData
      }

      columns.forEach((column, index) => {
        switch (column.property) {
          case 'codeDesc':
          case 'coder':
          case 'description':
          case 'patTypeDesc':
          case 'apc':
          case 'drName':
          case 'cliName':
          case 'projectName':
          case 'projectStartDate':
          case 'changeReason':
          case 'reason':
          case 'changeDesc':
          case 'physicianName':
          case 'code':
          case 'clientServiceLineName':
            if (index === 0 || (this.activateComparison && this.comparisonAccountsPRO.length && index === 1)) {
              sums[index] = 'Total'
            } else {
              sums[index] = ''
            }
            break
          case 'numRecords':
            sums[index] = this.totalSummary(column.property, data, index)
            break
          case 'totalRecords':
            sums[index] = this.codeTypeGrouping.length === 1 ? this.totalSummary(column.property, data, index) : '—'
            break
          case 'totalOccurrences':
            sums[index] = this.codeTypeGrouping.length === 1 ? this.totalSummary(column.property, data, index) : '—'
            break
          case 'number':
            sums[index] = this.codeTypeGrouping.length === 1 ? this.totalSummary(column.property, data, index) : '—'
            break
          case 'rvuDiff':
            value = this.totalSummary(column.property, data, index)
            td = document.querySelector(`.el-table__footer .${column.id}`)

            if (td && value) {
              if (this.grouping !== '5') {
                if (value.toString().replace(/[$]|[,]/g, '') < 0 && this.codeTypeGrouping.length) {
                  td.classList.add('negativeNumber_td')
                } else {
                  td.classList.remove('negativeNumber_td')
                }
              } else {
                if (value.toString().replace(/[$]|[,]/g, '') < 0) {
                  td.classList.add('negativeNumber_td')
                } else {
                  td.classList.remove('negativeNumber_td')
                }
              }
            }

            if (this.grouping !== '5') {
              sums[index] = this.codeTypeGrouping.length === 1 ? value : '—'
            } else {
              sums[index] = value
            }
            break
          case 'accuracyRate':
            sums[index] = this.codeTypeGrouping.length === 1 ? this.totalPercentSummaries(column.property, data, index, column) : '—'
            break
          case 'totalCodes':
            sums[index] = this.codeTypeGrouping.length === 1 ? this.totalPercentSummaries(column.property, data, index, column) : '—'
            break
          case 'cmCodes':
            sums[index] = this.codeTypeGrouping.length === 1 ? this.totalPercentSummaries(column.property, data, index, column) : '—'
            break
          case 'pcsCodes':
            sums[index] = this.codeTypeGrouping.length === 1 ? this.totalPercentSummaries(column.property, data, index, column) : '—'
            break
          case 'cptCodes':
            sums[index] = this.codeTypeGrouping.length === 1 ? this.totalPercentSummaries(column.property, data, index, column) : '—'
            break
          case 'modCodes':
            sums[index] = this.codeTypeGrouping.length === 1 ? this.totalPercentSummaries(column.property, data, index, column) : '—'
            break
          case 'apcCodes':
            sums[index] = this.codeTypeGrouping.length === 1 ? this.totalPercentSummaries(column.property, data, index, column) : '—'
            break
          case 'emCodes':
            sums[index] = this.codeTypeGrouping.length === 1 ? this.totalPercentSummaries(column.property, data, index, column) : '—'
            break
          case 'iiCodes':
            sums[index] = this.codeTypeGrouping.length === 1 ? this.totalPercentSummaries(column.property, data, index, column) : '—'
            break
          case 'siCodes':
            sums[index] = this.codeTypeGrouping.length === 1 ? this.totalPercentSummaries(column.property, data, index, column) : '—'
            break
          case 'financialImpact':
            value = this.totalMoneySummary(column.property, data, index)
            td = document.querySelector(`.el-table__footer .${column.id}`)
            if (td) {
              if (value.replace(/[$]|[,]/g, '') < 0 && this.codeTypeGrouping.length) {
                td.classList.add('negative_td')
              } else {
                td.classList.remove('negative_td')
              }
            }
            if (this.grouping !== '7') {
              sums[index] = this.codeTypeGrouping.length === 1 ? value : '—'
            } else {
              sums[index] = value
            }
            break
          case 'amt':
            value = this.totalMoneySummary(column.property, data, index)
            td = document.querySelector(`.el-table__footer .${column.id}`)
            if (td) {
              if (value.replace(/[$]|[,]/g, '') < 0 && this.codeTypeGrouping.length) {
                td.classList.add('negative_td')
              } else {
                td.classList.remove('negative_td')
              }
            }
            sums[index] = this.codeTypeGrouping.length === 1 ? value : '—'
            break
          default:
            sums[index] = 'n/a'
        }
      })

      return sums
    },
    totalPercentSummaries(column, data, index, columnArray) {
      let mt = 0
      let adr = 0
      for (let i = 0; i < data.length; i++) {
        // totalCodes Summary
        if (column === 'totalCodes') {
          if (!isNaN(Number(data[i]['dxNoRec'])) || !isNaN(Number(data[i]['dxAdditions'])) || !isNaN(Number(data[i]['dxDeletions'])) || !isNaN(Number(data[i]['dxRevisions'])) || !isNaN(Number(data[i]['emNoRec'])) || !isNaN(Number(data[i]['emAdditions'])) || !isNaN(Number(data[i]['emDeletions'])) || !isNaN(Number(data[i]['emRevisions'])) || !isNaN(Number(data[i]['cptNoRec'])) || !isNaN(Number(data[i]['cptAdditions'])) || !isNaN(Number(data[i]['cptDeletions'])) || !isNaN(Number(data[i]['cptRevisions'])) || !isNaN(Number(data[i]['modNoRec'])) || !isNaN(Number(data[i]['modAdditions'])) || !isNaN(Number(data[i]['modDeletions'])) || !isNaN(Number(data[i]['modRevisions']))) {
            mt += data[i]['dxNoRec'] + data[i]['dxAdditions'] + data[i]['dxDeletions'] + data[i]['dxRevisions'] + data[i]['emNoRec'] + data[i]['emAdditions'] + data[i]['emDeletions'] + data[i]['emRevisions'] + data[i]['cptNoRec'] + data[i]['cptAdditions'] + data[i]['cptDeletions'] + data[i]['cptRevisions'] + data[i]['modNoRec'] + data[i]['modAdditions'] + data[i]['modDeletions'] + data[i]['modRevisions']
          }

          if (!isNaN(Number(data[i]['dxAdditions'])) || !isNaN(Number(data[i]['dxDeletions'])) || !isNaN(Number(data[i]['dxRevisions']))) {
            adr += data[i]['dxAdditions'] + data[i]['dxDeletions'] + data[i]['dxRevisions'] + data[i]['emAdditions'] + data[i]['emDeletions'] + data[i]['emRevisions'] + data[i]['cptAdditions'] + data[i]['cptDeletions'] + data[i]['cptRevisions'] + data[i]['modAdditions'] + data[i]['modDeletions'] + data[i]['modRevisions']
          }
        }

        // cmCodes Summary
        if (column === 'cmCodes') {
          if (!isNaN(Number(data[i]['dxNoRec'])) || !isNaN(Number(data[i]['dxAdditions'])) || !isNaN(Number(data[i]['dxDeletions'])) || !isNaN(Number(data[i]['dxRevisions']))) {
            mt += data[i]['dxNoRec'] + data[i]['dxAdditions'] + data[i]['dxDeletions'] + data[i]['dxRevisions']
          }

          if (!isNaN(Number(data[i]['dxAdditions'])) || !isNaN(Number(data[i]['dxDeletions'])) || !isNaN(Number(data[i]['dxRevisions']))) {
            adr += data[i]['dxAdditions'] + data[i]['dxDeletions'] + data[i]['dxRevisions']
          }
        }

        // pcsCodes Summary
        if (column === 'pcsCodes') {
          if (!isNaN(Number(data[i]['pxNoRec'])) || !isNaN(Number(data[i]['pxAdditions'])) || !isNaN(Number(data[i]['pxDeletions'])) || !isNaN(Number(data[i]['pxRevisions']))) {
            mt += data[i]['pxNoRec'] + data[i]['pxAdditions'] + data[i]['pxDeletions'] + data[i]['pxRevisions']
          }

          if (!isNaN(Number(data[i]['pxAdditions'])) || !isNaN(Number(data[i]['pxDeletions'])) || !isNaN(Number(data[i]['pxRevisions']))) {
            adr += data[i]['pxAdditions'] + data[i]['pxDeletions'] + data[i]['pxRevisions']
          }
        }

        // cptCodes
        if (column === 'cptCodes') {
          if (!isNaN(Number(data[i]['cptNoRec'])) || !isNaN(Number(data[i]['cptAdditions'])) || !isNaN(Number(data[i]['cptDeletions'])) || !isNaN(Number(data[i]['cptRevisions']))) {
            mt += data[i]['cptNoRec'] + data[i]['cptAdditions'] + data[i]['cptDeletions'] + data[i]['cptRevisions']
          }

          if (!isNaN(Number(data[i]['cptAdditions'])) || !isNaN(Number(data[i]['cptDeletions'])) || !isNaN(Number(data[i]['cptRevisions']))) {
            adr += data[i]['cptAdditions'] + data[i]['cptDeletions'] + data[i]['cptRevisions']
          }
        }

        // modCodes
        if (column === 'modCodes') {
          if (!isNaN(Number(data[i]['modNoRec'])) || !isNaN(Number(data[i]['modAdditions'])) || !isNaN(Number(data[i]['modDeletions'])) || !isNaN(Number(data[i]['modRevisions']))) {
            mt += data[i]['modNoRec'] + data[i]['modAdditions'] + data[i]['modDeletions'] + data[i]['modRevisions']
          }

          if (!isNaN(Number(data[i]['modAdditions'])) || !isNaN(Number(data[i]['modDeletions'])) || !isNaN(Number(data[i]['modRevisions']))) {
            adr += data[i]['modAdditions'] + data[i]['modDeletions'] + data[i]['modRevisions']
          }
        }

        // apcCodes
        if (column === 'apcCodes') {
          if (!isNaN(Number(data[i]['apcNoRec'])) || !isNaN(Number(data[i]['apcAdditions'])) || !isNaN(Number(data[i]['apcDeletions'])) || !isNaN(Number(data[i]['apcRevisions']))) {
            mt += data[i]['apcNoRec'] + data[i]['apcAdditions'] + data[i]['apcDeletions'] + data[i]['apcRevisions']
          }

          if (!isNaN(Number(data[i]['apcAdditions'])) || !isNaN(Number(data[i]['apcDeletions'])) || !isNaN(Number(data[i]['apcRevisions']))) {
            adr += data[i]['apcAdditions'] + data[i]['apcDeletions'] + data[i]['apcRevisions']
          }
        }

        // emCodes
        if (column === 'emCodes') {
          if (!isNaN(Number(data[i]['emNoRec'])) || !isNaN(Number(data[i]['emAdditions'])) || !isNaN(Number(data[i]['emDeletions'])) || !isNaN(Number(data[i]['emRevisions']))) {
            mt += data[i]['emNoRec'] + data[i]['emAdditions'] + data[i]['emDeletions'] + data[i]['emRevisions']
          }

          if (!isNaN(Number(data[i]['emAdditions'])) || !isNaN(Number(data[i]['emDeletions'])) || !isNaN(Number(data[i]['emRevisions']))) {
            adr += data[i]['emAdditions'] + data[i]['emDeletions'] + data[i]['emRevisions']
          }
        }

        // iiCodes
        if (column === 'iiCodes') {
          if (!isNaN(Number(data[i]['iiNoRec'])) || !isNaN(Number(data[i]['iiAdditions'])) || !isNaN(Number(data[i]['iiDeletions'])) || !isNaN(Number(data[i]['iiRevisions']))) {
            mt += data[i]['iiNoRec'] + data[i]['iiAdditions'] + data[i]['iiDeletions'] + data[i]['iiRevisions']
          }

          if (!isNaN(Number(data[i]['iiAdditions'])) || !isNaN(Number(data[i]['iiDeletions'])) || !isNaN(Number(data[i]['iiRevisions']))) {
            adr += data[i]['iiAdditions'] + data[i]['iiDeletions'] + data[i]['iiRevisions']
          }
        }

        // siCodes
        if (column === 'siCodes') {
          if (!isNaN(Number(data[i]['siNoRec'])) || !isNaN(Number(data[i]['siAdditions'])) || !isNaN(Number(data[i]['siDeletions'])) || !isNaN(Number(data[i]['siRevisions']))) {
            mt += data[i]['siNoRec'] + data[i]['siAdditions'] + data[i]['siDeletions'] + data[i]['siRevisions']
          }

          if (!isNaN(Number(data[i]['siAdditions'])) || !isNaN(Number(data[i]['siDeletions'])) || !isNaN(Number(data[i]['siRevisions']))) {
            adr += data[i]['siAdditions'] + data[i]['siDeletions'] + data[i]['siRevisions']
          }
        }

        // dx table accuracy rate
        if (columnArray.label === 'Accuracy Rate') {
          const revisions = this.isPriDxGrouping() ? this.priDxRevisionCount(data[i]) : (isNaN(Number(data[i]['numOfRevisions'])) ? 0 : data[i]['numOfRevisions'])
          if (!isNaN(Number(data[i]['numOfNoRec'])) || !isNaN(Number(data[i]['numOfAdditions'])) || !isNaN(Number(data[i]['numOfDeletions'])) || revisions) {
            mt += data[i]['numOfNoRec'] + data[i]['numOfAdditions'] + data[i]['numOfDeletions'] + revisions
          }

          if (!isNaN(Number(data[i]['numOfAdditions'])) || !isNaN(Number(data[i]['numOfDeletions'])) || revisions) {
            adr += data[i]['numOfAdditions'] + data[i]['numOfDeletions'] + revisions
          }
        }
      }

      return mt || adr ? this.calculatePercentages(mt, adr) : 'N/A'
    },
    totalAPCPercentSummary(column, data, index) {
      let mt = 0
      let adr = 0
      for (let i = 0; i < data.length; i++) {
        // apcCodes
        if (column === 'apcCodes') {
          if (!isNaN(Number(data[i]['noRec'])) || !isNaN(Number(data[i]['additions'])) || !isNaN(Number(data[i]['deletions'])) || !isNaN(Number(data[i]['revisions']))) {
            mt += data[i]['noRec'] + data[i]['additions'] + data[i]['deletions'] + data[i]['revisions']
          }

          if (!isNaN(Number(data[i]['additions'])) || !isNaN(Number(data[i]['deletions'])) || !isNaN(Number(data[i]['revisions']))) {
            adr += data[i]['additions'] + data[i]['deletions'] + data[i]['revisions']
          }
        }
      }
      return this.calculatePercentages(mt, adr)
    },
    totalSummary(column, data, index) {
      // let groupValue = this.dropdown.filter(x => x.key === this.grouping)[0]
      let response = data.reduce((total, curr) => {
        const value = Number(curr[column])
        if (!isNaN(value)) {
          return total + curr[column]
        } else {
          return total
        }
      }, 0)

      return response % 1 === 0 ? response : response.toFixed(2)
    },
    totalMoneySummary(column, data, index) {
      let response = data.reduce((total, curr) => {
        const value = Number(curr[column])
        if (!isNaN(value)) {
          return total + curr[column]
        } else {
          return total
        }
      }, 0)
      return this.moneyFormatter(response)
    },
    calculatePercentages(masterTotal, adrTotal) {
      let response = masterTotal === null || masterTotal === 0 ? 0 : 1 - adrTotal / masterTotal
      return `${(response * 100).toFixed(2)}%`
    },
    checkPercentValues(column, scope, table) {
      let response = false
      switch (column) {
        case 'Total APC':
          if (table === 'apc') {
            if (!scope.row.noRec && !scope.row.additions && !scope.row.deletions && !scope.row.revisions) {
              response = true
            }
          } else {
            if (!scope.row.apcNoRec && !scope.row.apcAdditions && !scope.row.apcDeletions && !scope.row.apcRevisions) {
              response = true
            }
          }
          break
        case 'Total Codes':
          if (!scope.row.dxNoRec && !scope.row.emNoRec && !scope.row.cptNoRec && !scope.row.modNoRec && !scope.row.dxAdditions && !scope.row.emAdditions && !scope.row.cptAdditions && !scope.row.modAdditions && !scope.row.dxDeletions && !scope.row.emDeletions && !scope.row.cptDeletions && !scope.row.modDeletions && !scope.row.dxRevisions && !scope.row.emRevisions && !scope.row.cptRevisions && !scope.row.modRevisions) {
            response = true
          }
          break
        case 'ICD-10 CM Codes':
          if (!scope.row.dxNoRec && !scope.row.dxAdditions && !scope.row.dxDeletions && !scope.row.dxRevisions) {
            response = true
          }
          break
        case 'ICD-10 PCS Codes':
          if (!scope.row.pxNoRec && !scope.row.pxAdditions && !scope.row.pxDeletions && !scope.row.pxRevisions) {
            response = true
          }
          break
        case 'CPT Codes':
          if (!scope.row.cptNoRec && !scope.row.cptAdditions && !scope.row.cptDeletions && !scope.row.cptRevisions) {
            response = true
          }
          break
        case 'MOD Codes':
          if (!scope.row.modNoRec && !scope.row.modAdditions && !scope.row.modDeletions && !scope.row.modRevisions) {
            response = true
          }
          break
        case 'E/M Codes':
          if (!scope.row.emNoRec && !scope.row.emAdditions && !scope.row.emDeletions && !scope.row.emRevisions) {
            response = true
          }
          break
        case 'I&I Codes':
          if (!scope.row.iiNoRec && !scope.row.iiAdditions && !scope.row.iiDeletions && !scope.row.iiRevisions) {
            response = true
          }
          break
        case 'S&I Codes':
          if (!scope.row.siNoRec && !scope.row.siAdditions && !scope.row.siDeletions && !scope.row.siRevisions) {
            response = true
          }
          break
        case 'dx cmCodes':
          if (!scope.row.numOfAdditions && !scope.row.numOfDeletions && !scope.row.numOfNoRec && !scope.row.numOfRevisions) {
            response = true
          }
          break
        case 'rvu':
          if (!scope.row.rvuDiff && !scope.row.rvuDiff && !scope.row.rrigWorkRvu && !scope.row.recommendedWorkRvu) {
            response = true
          }
          break
      }

      return response
    },
    handleCurrentChange(val) {
      this.currentPage = val
    },
    handleSortChange({ prop, order }) {
      this.sortProp = prop
      this.sortOrder = order
      this.currentPage = 1
    },
    sortData(data) {
      if (!this.sortProp || !this.sortOrder) return data
      const sorted = [...data]
      const modifier = this.sortOrder === 'ascending' ? 1 : -1
      sorted.sort((a, b) => {
        const valA = a[this.sortProp]
        const valB = b[this.sortProp]
        if (valA == null && valB == null) return 0
        if (valA == null) return 1
        if (valB == null) return -1
        if (typeof valA === 'string') return valA.localeCompare(valB) * modifier
        return (valA - valB) * modifier
      })
      return sorted
    },
    getBedSizeValue(groupKey, value, prop, codeType, allData, patType = null, table = '') {
      let response = '—'
      if (this.comparisonAccountsPRO.length) {
        let index
        switch (table) {
          case 'dx':
            index = this.comparisonAccountsPRO.findIndex(x => x.groupKey === groupKey && x.type === 'profee all review' && x.title === 'By Dx')
            break
          case 'sdoh':
            index = this.comparisonAccountsPRO.findIndex(x => x.groupKey === groupKey && x.type === 'profee all review' && x.title === (this.grouping === '18' ? 'By Pri Dx' : 'By SDOH Dx'))
            break
          case 'hcc':
            index = this.comparisonAccountsPRO.findIndex(x => x.groupKey === groupKey && x.type === 'profee all review' && x.title === 'By HCC')
            break
          case 'hccv28':
            index = this.comparisonAccountsPRO.findIndex(x => x.groupKey === groupKey && x.type === 'profee all review' && x.title === 'By HCC V28')
            break
          case 'cpt':
            index = this.comparisonAccountsPRO.findIndex(x => x.groupKey === groupKey && x.type === 'profee all review' && x.title === 'By CPT')
            break
          case 'mod':
            index = this.comparisonAccountsPRO.findIndex(x => x.groupKey === groupKey && x.type === 'profee all review' && x.title === 'By MOD')
            break
          case 'em':
            index = this.comparisonAccountsPRO.findIndex(x => x.groupKey === groupKey && x.type === 'profee all review' && x.title === 'By EM')
            break
          default:
            index = this.comparisonAccountsPRO.findIndex(x => x.groupKey === groupKey && x.type === 'profee all review')
        }

        if (index !== -1) {
          let found = {}
          if (groupKey === 'cliName' || groupKey === 'projectName') {
            found = this.comparisonAccountsPRO[index].data.find(x => x.codeDesc === codeType)
          } else {
            found = patType === null ? this.comparisonAccountsPRO[index].data.find(x => x[groupKey] === value && x.codeDesc === codeType) : this.comparisonAccountsPRO[index].data.find(x => x[groupKey] === value && x.codeDesc === codeType && x.patType === patType)
          }

          if (found) {
            let percents = ['totalCodes', 'cmCodes', 'cptCodes', 'modCodes', 'emCodes', 'accuracyRate']
            let money = ['financialImpact', 'amt']
            response = found[prop]
            // display formats
            if (percents.some(x => x === prop)) {
              response = `${(found[prop] * 100).toFixed(2)}%`
            }

            if (money.some(x => x === prop)) {
              response = this.moneyFormatter(found[prop])
            }
          }
          return response
        }
      }
      return response
    },
    isCodeGrouping() {
      return false
    },
    convertHccs(delimited) {
      if (delimited) {
        let retArray = delimited.split('-')
        return retArray
      } else {
        return []
      }
    },
    getHccTitle(id) {
      if (id) {
        let data = []
        let ipIndex = this.reviewDashboardData.findIndex(x => x.type === 'profee') > -1 ? this.reviewDashboardData.findIndex(x => x.type === 'profee') : null
        let grouping = 'HCCs'
        let groupIndex = this.reviewDashboardData[ipIndex].largeStats.findIndex(x => x.title === grouping)
        data = this.reviewDashboardData[ipIndex].largeStats.some(x => x.title === grouping) ? this.reviewDashboardData[ipIndex].largeStats[groupIndex].data : []

        let filteredList = data.filter(a => a.hccId === id)
        if (filteredList.length > 0) {
          return filteredList[0].description
        } else {
          return ''
        }
      } else {
        return ''
      }
    },
    formatDate(date) {
      return format(parseISO(date), 'MM/dd/yyyy')
    }
  },
  created: function() {
    this._summaryHandlers = []
  },
  mounted() {
    this.$nextTick(() => {
      this.attachSummaryClickHandlers()
    })
  },
  updated() {
    this.$nextTick(() => {
      this.attachSummaryClickHandlers()
    })
  },
  beforeDestroy() {
    this.cleanupSummaryHandlers()
  },
  watch: {
    grouping() {
      this.currentPage = 1
      this.sortProp = ''
      this.sortOrder = ''
    },
    reviewDashboardData: {
      handler() {
        this.$nextTick(() => {
          let tableRef = this.getActiveTableRef()
          if (tableRef && this.$refs[tableRef]) {
            this.$refs[tableRef].doLayout()
          }
          this.$nextTick(() => {
            this.attachSummaryClickHandlers()
          })
        })
      },
      deep: true
    }
  },
  computed: {
    ...mapState('user/', ['currentClient', 'currentClientId']),
    ...mapState('dashboard/', ['dashboardData', 'dashboardProjects', 'reviewDashboardData', 'comparisonAccountsPRO']),
    coderTableData() {
      return this.getTableData('By Coder')
    },
    coderTrendingTableData() {
      return this.getTableData('By Coder Trending')
    },
    patientTypeTableData() {
      return this.getTableData('By Patient Type')
    },
    apcTableData() {
      return this.getTableData('By APC')
    },
    facilityTableData() {
      return this.getTableData('By Facility')
    },
    projectTableData() {
      return this.getTableData('By Project')
    },
    reasonTableData() {
      return this.getTableData('By Reason')
    },
    headerReasonTableData() {
      return this.getTableData('By Header Reason')
    },
    dxTableData() {
      return this.getTableData('By Dx')
    },
    sdohTableData() {
      return this.getTableData(this.grouping === '18' ? 'By Pri Dx' : 'By SDOH Dx')
    },
    hccTableData() {
      return this.getTableData('By HCC')
    },
    hccV28TableData() {
      return this.getTableData('By HCC V28')
    },
    cptTableData() {
      return this.getTableData('By CPT')
    },
    modTableData() {
      return this.getTableData('By MOD')
    },
    pxTableData() {
      return this.getTableData('By Px')
    },
    emTableData() {
      return this.getTableData('By EM')
    },
    providerTableData() {
      return this.getTableData('By Provider')
    },
    providerTrendingTableData() {
      return this.getTableData('By Provider Trending')
    },
    emLevelSummaryData() {
      return this.getTableData('EM Leveling')
    },
    serviceLineTableData() {
      return this.getTableData('By Service Line')
    },
    coderTablePagination() {
      let length = this.coderTableData.length
      let from = length <= this.itemsPerPage ? 0 : (this.currentPage - 1) * this.itemsPerPage + 1
      let to = this.currentPage * this.itemsPerPage
      return this.coderTableData.slice(from, to)
    },
    coderTrendingTablePagination() {
      let length = this.coderTableData.length
      let from = length <= this.itemsPerPage ? 0 : (this.currentPage - 1) * this.itemsPerPage + 1
      let to = this.currentPage * this.itemsPerPage
      return this.coderTrendingTableData.slice(from, to)
    },
    patientTypeTablePagination() {
      let length = this.patientTypeTableData.length
      let from = length <= this.itemsPerPage ? 0 : (this.currentPage - 1) * this.itemsPerPage + 1
      let to = this.currentPage * this.itemsPerPage
      return this.patientTypeTableData.slice(from, to)
    },
    apcTableDataPagination() {
      let length = this.apcTableData.length
      let from = length <= this.itemsPerPage ? 0 : (this.currentPage - 1) * this.itemsPerPage + 1
      let to = this.currentPage * this.itemsPerPage
      return this.apcTableData.slice(from, to)
    },
    facilityTablePagination() {
      let length = this.facilityTableData.length
      let from = length <= this.itemsPerPage ? 0 : (this.currentPage - 1) * this.itemsPerPage + 1
      let to = this.currentPage * this.itemsPerPage
      return this.facilityTableData.slice(from, to)
    },
    projectTablePagination() {
      let length = this.projectTableData.length
      let from = length <= this.itemsPerPage ? 0 : (this.currentPage - 1) * this.itemsPerPage + 1
      let to = this.currentPage * this.itemsPerPage
      return this.projectTableData.slice(from, to)
    },
    reasonTablePagination() {
      let length = this.reasonTableData.length
      let from = length <= this.itemsPerPage ? 0 : (this.currentPage - 1) * this.itemsPerPage + 1
      let to = this.currentPage * this.itemsPerPage
      return this.reasonTableData.slice(from, to)
    },
    headerReasonTablePagniation() {
      let length = this.headerReasonTableData.length
      let from = length <= this.itemsPerPage ? 0 : (this.currentPage - 1) * this.itemsPerPage + 1
      let to = this.currentPage * this.itemsPerPage
      return this.headerReasonTableData.slice(from, to)
    },
    dxTablePagination() {
      let localItemsPerPage = this.isCodeGrouping() ? this.codeItemsPerPage : this.itemsPerPage
      let length = this.dxTableData.length
      let from = length <= this.itemsPerPage ? 0 : (this.currentPage - 1) * localItemsPerPage + 1
      let to = this.currentPage * localItemsPerPage
      return this.sortData(this.dxTableData).slice(from, to)
    },
    sdohTablePagination() {
      let localItemsPerPage = this.isCodeGrouping() ? this.codeItemsPerPage : this.itemsPerPage
      let length = this.sdohTableData.length
      let from = length <= this.itemsPerPage ? 0 : (this.currentPage - 1) * localItemsPerPage + 1
      let to = this.currentPage * localItemsPerPage
      return this.sortData(this.sdohTableData).slice(from, to)
    },
    hccTablePagination() {
      let localItemsPerPage = this.isCodeGrouping() ? this.codeItemsPerPage : this.itemsPerPage
      let length = this.hccTableData.length
      let from = length <= this.itemsPerPage ? 0 : (this.currentPage - 1) * localItemsPerPage + 1
      let to = this.currentPage * localItemsPerPage
      return this.sortData(this.hccTableData).slice(from, to)
    },
    hccV28TablePagination() {
      let localItemsPerPage = this.isCodeGrouping() ? this.codeItemsPerPage : this.itemsPerPage
      let length = this.hccV28TableData.length
      let from = length <= this.itemsPerPage ? 0 : (this.currentPage - 1) * localItemsPerPage + 1
      let to = this.currentPage * localItemsPerPage
      return this.sortData(this.hccV28TableData).slice(from, to)
    },
    cptTablePagination() {
      let localItemsPerPage = this.isCodeGrouping() ? this.codeItemsPerPage : this.itemsPerPage
      let length = this.cptTableData.length
      let from = length <= this.itemsPerPage ? 0 : (this.currentPage - 1) * localItemsPerPage + 1
      let to = this.currentPage * localItemsPerPage
      return this.sortData(this.cptTableData).slice(from, to)
    },
    modTablePagination() {
      let length = this.modTableData.length
      let from = length <= this.itemsPerPage ? 0 : (this.currentPage - 1) * this.itemsPerPage + 1
      let to = this.currentPage * this.itemsPerPage
      return this.sortData(this.modTableData).slice(from, to)
    },
    pxTablePagination() {
      let localItemsPerPage = this.isCodeGrouping() ? this.codeItemsPerPage : this.itemsPerPage
      let length = this.pxTableData.length
      let from = length <= this.itemsPerPage ? 0 : (this.currentPage - 1) * localItemsPerPage + 1
      let to = this.currentPage * localItemsPerPage
      return this.pxTableData.slice(from, to)
    },
    emTablePagination() {
      let localItemsPerPage = this.isCodeGrouping() ? this.codeItemsPerPage : this.itemsPerPage
      let length = this.emTableData.length
      let from = length <= this.itemsPerPage ? 0 : (this.currentPage - 1) * localItemsPerPage + 1
      let to = this.currentPage * localItemsPerPage
      return this.sortData(this.emTableData).slice(from, to)
    },
    providerTablePagination() {
      let length = this.providerTableData.length
      let from = length <= this.itemsPerPage ? 0 : (this.currentPage - 1) * this.itemsPerPage + 1
      let to = this.currentPage * this.itemsPerPage
      return this.providerTableData.slice(from, to)
    },
    providerTrendingTablePagination() {
      let length = this.providerTrendingTableData.length
      let from = length <= this.itemsPerPage ? 0 : (this.currentPage - 1) * this.itemsPerPage + 1
      let to = this.currentPage * this.itemsPerPage
      return this.providerTrendingTableData.slice(from, to)
    },
    serviceLineTablePagination() {
      let length = this.serviceLineTableData.length
      let from = length <= this.itemsPerPage ? 0 : (this.currentPage - 1) * this.itemsPerPage + 1
      let to = this.currentPage * this.itemsPerPage
      return this.serviceLineTableData.slice(from, to)
    },
    paginationTotal() {
      let length = 0
      switch (this.grouping) {
        case '1':
          length = this.coderTableData.length
          break
        case '15':
          length = this.coderTrendingTableData.length
          break
        case '2':
          length = this.providerTableData.length
          break
        case '14':
          length = this.providerTrendingTableData.length
          break
        case '3':
          length = this.patientTypeTableData.length
          break
        case '4':
          length = this.facilityTableData.length
          break
        case '17':
          length = this.projectTableData.length
          break
        case '5':
          length = this.reasonTableData.length
          break
        case '6':
          length = this.dxTableData.length
          break
        case '13':
          length = this.sdohTableData.length
          break
        case '18':
          length = this.sdohTableData.length
          break
        case '7':
          length = this.cptTableData.length
          break
        case '8':
          length = this.modTableData.length
          break
        case '9':
          length = this.emTableData.length
          break
        case '10':
          length = this.hccTableData.length
          break
        case '12':
          length = this.hccV28TableData.length
          break
        case '16':
          length = this.serviceLineTableData.length
          break
      }
      return length
    },
    paginationSummaries() {
      let data = []
      switch (this.grouping) {
        case '1':
          data = this.coderTableData
          break
        case '15':
          data = this.coderTrendingTableData
          break
        case '2':
          data = this.providerTableData
          break
        case '14':
          data = this.providerTableData
          break
        case '3':
          data = this.patientTypeTableData
          break
        case '4':
          data = this.facilityTableData
          break
        case '17':
          data = this.projectTableData
          break
        case '5':
          data = this.reasonTableData
          break
        case '6':
          data = this.dxTableData
          break
        case '13':
          data = this.sdohTableData
          break
        case '18':
          data = this.sdohTableData
          break
        case '7':
          data = this.cptTableData
          break
        case '8':
          data = this.modTableData
          break
        case '9':
          data = this.emTableData
          break
        case '16':
          data = this.serviceLineTableData
          break
      }
      return data
    },
    codeGroupingAllData() {
      let data = []
      switch (this.grouping) {
        case '6':
          data = this.dxTableData
          break
        case '13':
          data = this.sdohTableData
          break
        case '18':
          data = this.sdohTableData
          break
        case '7':
          data = this.cptTableData
          break
        case '8':
          data = this.modTableData
          break
        case '9':
          data = this.emTableData
          break
        case '10':
          data = this.hccTableData
          break
        case '12':
          data = this.hccV28TableData
          break
      }
      return data
    }
  }
}
</script>

<style scoped>
.qmDisclaimer {
  font-size: 10px;
  font-style: italic;
  margin: 5px 0px 0px 0px;
  color: #909399;
}
.priDxDisclaimer {
  font-size: 11px;
}
/* .negative {
      color: #f56c6c;
    }

    .negative::before {
      content: '(';
    }

    .negative::after {
      content: ')';
    } */

/* Element UI: sort changes header height but does not rerun layout; body-wrapper keeps a stale
   inline height so header + body + summary exceeds fixed height and the footer is clipped. */
#proData >>> .el-table {
  display: flex;
  flex-direction: column;
}
#proData >>> .el-table__header-wrapper,
#proData >>> .el-table__footer-wrapper {
  flex-shrink: 0;
}
#proData >>> .el-table__body-wrapper {
  flex: 1 1 0;
  min-height: 0;
  height: auto !important;
}
</style>
